export default {
    salesforceNavigation: {
        openContractAssets: "Ouvrir les actifs du contrat propriétaire dans Salesforce",
        assetsLabel: "Actifs SF",
        openAccount: "Ouvrir le compte dans Salesforce",
        openContract: "Ouvrir le contrat dans Salesforce",
        loading: "Chargement du lien Salesforce",
        popupBlocked: "Le navigateur a bloqué l'onglet. Autorisez les fenêtres contextuelles et réessayez.",
        NotLinked: "Aucun enregistrement correspondant dans Salesforce",
        Ambiguous: "Plusieurs enregistrements Salesforce correspondent ; lien indisponible",
        Unavailable: "Lien Salesforce indisponible",
    },
    supportOrders: {
        executionFailed: "Échec de l'exécution",
        awaitingManualExecution: "En attente d'exécution manuelle",
        awaitingExecution: "En attente d'exécution",
        waitingForAgreement: "En attente d'un contrat d'assistance",
        followUpTitle: "Commandes Salesforce nécessitant un suivi",
    },
    licenseUsageSummary: {
        daysUsed: "Jours d'utilisation",
        userDays: "Jours-utilisateurs",
        failures: "Refus",
        userDetails: "Détails de l'utilisateur",
        productsTab: "Produits",
        graphTab: "Graphique",
        productsTitle: "Utilisation par produit",
        productDetails: "Détails du produit",
        productUsageInfo: "Les totaux par produit utilisent les licences en ligne incluses. Les utilisateurs uniques sont dédupliqués ; les jours-utilisateurs restent additionnés par utilisateur et licence. Les refus non attribués sont inclus indépendamment du filtre des licences inactives. Le pic d'occupation et la plage de capacité enregistrée sont affichés directement lorsqu'une seule licence est incluse.",
        seeLicenseDetails: "Voir les détails des licences",
        multipleLicensePeaksInfo: "Certains produits comportent plusieurs licences incluses. Leurs pics d'occupation et plages de capacité enregistrées ne peuvent pas être combinés de manière fiable ; développez le produit pour voir ces valeurs par licence.",
        productUnassignedFailuresInfo: "Ces refus sont inclus dans le total du produit, mais ne peuvent pas être attribués sans ambiguïté à une licence.",
        noProductLicenses: "Aucune licence n'est incluse pour ce produit avec les filtres actuels.",
        noUnassignedProductFailures: "Aucun refus non attribué n'est enregistré pour ce produit sur la période.",
        usageTab: "Utilisation",
        rejectionsTab: "Refus ({{count}})",
        noLicenseTab: "Aucune licence disponible ({{count}})",
        userUnassignedFailuresInfo: "Ces refus sont inclus dans le total de cet utilisateur, mais ne peuvent pas être attribués sans ambiguïté à une licence. Ils sont regroupés par produit.",
        noUnassignedUserFailures: "Aucun refus sans licence identifiable n'est enregistré pour cet utilisateur sur la période.",
        noUserLicenses: "Aucune utilisation de licence ni aucun refus attribué à une licence n'est affiché pour cet utilisateur avec les filtres actuels.",
        allSeatsOccupied: "Refus : tous les postes occupés",
        noLicenseAvailable: "Refus : aucune licence disponible",
        productCode: "Code produit",
        attribution: "Attribution à une licence",
        NoMatchingLicense: "Licence introuvable dans l'inventaire sélectionné",
        NoLicenseReference: "Aucune référence de licence enregistrée",
        AmbiguousLicense: "Plusieurs licences correspondent au numéro de licence et au code produit enregistrés",
        ProductMismatch: "Code produit absent ou incohérent",
        unassignedFailures: "Refus non attribués à une licence",
        unassignedFailuresInfo: "Les refus sont regroupés par produit. Développez un produit pour voir les utilisateurs et clients enregistrés. Les nombres de refus figurent sur les lignes des utilisateurs, sans être attribués à une licence ni comptés comme utilisation. Ces événements ne dépendent pas du filtre des licences inactives.",
        daysAndFailuresInfo: "Un jour-utilisateur correspond à un utilisateur utilisant une licence à une date UTC enregistrée. Plusieurs sessions le même jour comptent une seule fois ; les totaux additionnent les jours par utilisateur et licence. Seuls les refus pour postes occupés et licence indisponible sont comptés. Un utilisateur ayant uniquement des refus a une utilisation nulle. Ces chiffres reflètent l'historique enregistré, pas un rapprochement avec la facturation Autodesk.",
        title: "Utilisation des licences",
        usersTitle: "Utilisation par utilisateur",
        perspective: "Vue du rapport",
        reportInfo: "À propos du rapport",
        reportInfoWithWarnings: "À propos du rapport : données d'utilisation incomplètes",
        licensesTab: "Licences",
        usersTab: "Utilisateurs",
        licensesUsed: "Licences utilisées",
        userHours: "Heures d'utilisation de l'utilisateur",
        noRecordedUsers: "Aucune activité utilisateur n'est enregistrée pour les licences correspondant aux filtres et à la période sélectionnés.",
        currentSeats: "Postes aujourd'hui",
        recordedSeats: "Postes enregistrés",
        unknown: "Inconnu",
        showInactive: "Afficher les licences inactives",
        terminationDate: "Date de résiliation",
        peakOccupiedSeats: "Utilisateurs simultanés max.",
        uniqueUsers: "Utilisateurs uniques",
        hours: "Heures d'utilisation",
        empty: "Aucune licence avec gestion des accès ne correspond aux filtres sélectionnés.",
        noUsers: "Aucune activité utilisateur n'est enregistrée pour cette licence sur la période.",
        historicalModuleUsageInfo: "Lorsqu'un module n'a pas de date de début, celle de la session principale est utilisée comme estimation. Cela peut surestimer les heures d'utilisation, les utilisateurs simultanés max. et les jours-utilisateurs. Les données historiques peuvent aussi refléter toute la session principale plutôt que l'utilisation réelle du module. L'utilisation estimée est comptée comme utilisation, pas comme jours-postes exclus.",
        excludedSeatDays: "Jours-postes exclus",
        incompleteSeatCoverage: "Données d'utilisation incomplètes pour les licences {{licenses}} : les postes sans date de début valide sont exclus. Les heures, les pics et le nombre d'utilisateurs peuvent être sous-estimés ; zéro ne signifie pas nécessairement aucune utilisation. Chaque poste concerné est compté une fois par jour dans les jours-postes exclus.",
    },
    "app": {
        "customers": "Clients",
        "customerDetails": "Détails du client",
        "contracts": "Contrats",
        "userSupport": "Support utilisateur",
        "productList": "Liste des produits",
        "licenses": "Licences",
        "activeUsers": "Utilisateurs actifs",
        "loginFailed": "Échec de connexion",
        "rejectedLogin": "Connexion refusée",
        "licenseExploitation": "Exploitation des licences",
        "personActivity": "Activité de la personne",
        "expiredLicenses": "Licences expirées",
        "offlineLicenses": "Licences hors ligne",
        "system": "Système",
        "licenseChanges": "Modifications des licences",
        "webUpdates": "Mises à jour web",
        "reports": "Rapports",
        "newSales": "Nouvelles ventes",
        "renewals": "Renouvellements",
        "churn": "Attrition",
        "graphs": "Graphiques",
        "licenseUsage": "Utilisation des licences",
        "sale": "Vente",
        "other": "Autre",
        "productStructure": "Structure du produit",
        "productVersion": "Version du produit",
        "course": "Cours",
        "checkFocusAccount": "Vérifier le compte Focus",
        "emails": "Emails",
        "offers": "Offres",
        "kuaAdmin": "Admin Kua",
        "company": "Entreprise",
        "futureRenewals": "Renouvellements futurs",
        "requests": "Demandes",
        "myPageStatus": "Statut de Ma Page",
        "secretPages": "Pages secrètes",
        "courseAdmin": "Admin Cours",
        "courseCatalog": "Catalogue des cours",
        "courseList": "Liste des cours",
        "courseEvaluation": "Évaluation du cours",
        "resources": "Ressources",
        "informationTexts": "Textes d'information",
        "emailTemplates": "Modèles d'emails",
        "users": "Utilisateurs",
        "autodeskOpportunities": "Opportunités",
        licenseAccess: "Accès à la licence",
        assetSync: "Sync de licence SF",
        accountReconciliation: "Comparaison SF"
    },
    salesForceAccountReconciliation: {
        sync: {
            column: "Action", button: "Sync SF → WK", warningButton: "Sync SF → WK (avertissement)",
            savedButton: "Ordre enregistré", title: "Synchroniser le compte {{number}} de SF vers WK",
            tooltip: "Champs à synchroniser de SF vers WK : {{fields}}.",
            blockedLink: "Synchronisation impossible : le lien client est incomplet.",
            description: "SF est la source des champs comparés, y compris les valeurs vides. La ville de visite correspond à WK Place ; BillingCity à la ville postale. Payer code et les champs d'adresse supplémentaires sont conservés.",
            billingCityWarning: "Vérifier la ville de visite SF avant la synchronisation : BillingCity ({{city}}) correspond à WK, mais la ville de visite diffère ou est vide. La synchronisation utilise la ville de visite, pas BillingCity.",
            clearWarning: "Attention : les valeurs SF manquantes supprimeront les valeurs WK existantes dans ces champs.",
            blocked: "La synchronisation exige un client unique dans chaque système et des champs/codes pays connus.",
            preview: "Écarts actuels avant synchronisation", loading: "Vérification ou envoi de l'ordre …",
            confirm: "Confirmer et envoyer l'ordre", close: "Fermer", newPreview: "Actualiser l'aperçu",
            retry: "Vérifier le même envoi", refresh: "Vérifier à nouveau le rapport",
            submitted: "L'ordre a été envoyé. Cela ne confirme pas la fin de la synchronisation. Vérifier son statut et actualiser le rapport après exécution.",
            recorded: "Cet ordre est déjà enregistré et n'a pas été renvoyé. Vérifier son statut ; son exécution n'est pas confirmée ici.",
            orderId: "ID de l'ordre : {{id}}",
            errors: {
                InvalidPreview: "La confirmation a expiré ou est invalide. Actualiser l'aperçu.",
                SourceChanged: "Les données SF ou WK ont changé depuis l'aperçu. Vérifier les nouvelles valeurs avant synchronisation.",
                AmbiguousLink: "La liaison client n'est plus unique. Vérifier le numéro client, les ID sources et les doublons.",
                NoLongerEligible: "L'Account SF n'a plus de Contract. Synchronisation bloquée.",
                NoDifferences: "Aucun écart à synchroniser. Actualiser le rapport.",
                SellerUnresolved: "L'e-mail du vendeur SF ne correspond pas à un utilisateur WK unique. Synchronisation bloquée.",
                UnknownCountry: "Le code pays SF n'est pas reconnu. Synchronisation bloquée.",
                OperatorUnresolved: "L'utilisateur connecté ne correspond pas à un utilisateur WK unique.",
                PendingOrder: "Un ordre de mise à jour Account est déjà ouvert. Le vérifier avant une nouvelle synchronisation.",
                OrderConflict: "Un ordre existant n'a pas pu être associé de manière sûre à cette action. Vérifier l'ordre.",
                DispatchFailed: "L'ordre est enregistré, mais l'envoi à l'orchestrateur n'est pas confirmé. Vérifier l'ordre avant une nouvelle synchronisation.",
                IncompleteSource: "La réponse SF ne contient pas tous les champs sélectionnés. Synchronisation bloquée pour éviter une suppression involontaire.",
                RequestFailed: "La requête n'a pas pu être confirmée. L'ordre peut déjà être enregistré. Vérifier le même envoi ou son statut avant une nouvelle synchronisation."
            }
        },
        contractScope: "Les Accounts SF sans Contract ne sont pas comparés. Exclus de la sélection récupérée : {{excluded}}. Tous les statuts de Contract sont pris en compte.",
        contractScopeCountUnavailable: "Le filtre Contract est appliqué, mais le nombre d'Accounts SF exclus est absent ou invalide. Actualiser le rapport.",
        salesforceAccount: "Client SF", webkuaAccount: "Client WK",
        salesforceName: "Nom du client SF", webkuaName: "Nom du client WK",
        mainFinding: "Constat principal", allFindings: "Tous les constats", differences: "Écarts de champs (valeurs brutes)",
        canSyncFilter: "Synchronisation possible ({{count}})",
        differencesTitle: "Différences", nextCheck: "À vérifier",
        moreFindings_one: "1 autre constat", moreFindings_other: "{{count}} autres constats",
        notFound: "Non trouvé", notCompared: "Non comparé",
        notReported: "Non renseigné", emptyValue: "Valeur vide",
        sourceLimitations: "Le rapport contient les noms et les champs différents, pas les documents clients complets. Les champs identiques ne sont pas affichés.",
        missingSalesforceKey: "Le client SF n'a pas de numéro client WebKUA. La liaison ne peut pas être vérifiée.",
        missingWebkuaKey: "Le client WK n'a pas de numéro client. La liaison ne peut pas être vérifiée.",
        notFoundInWebkua: "Le client SF n'a pas été trouvé dans WK.",
        notFoundInSalesforce: "Le client WK n'a pas été trouvé dans SF.",
        ambiguousCustomer: "Le numéro client appartient à plusieurs clients. La liaison est ambiguë.",
        unknownComparisonField: "Champ de comparaison inconnu.",
        fieldMismatch: "{{field}} diffère.", missingField: "{{field}} n'est pas renseigné dans {{system}}.",
        unrecognizedCountry: "Le code pays SF n'est pas reconnu.",
        unknownField: "Champ de comparaison inconnu : {{field}}",
        noFindingDetails: "Aucun écart de champ précis fourni. Vérifier les données sources.",
        filteredRows: "{{shown}} lignes affichées sur {{total}}.", clearFilters: "Réinitialiser les filtres de constats",
        filters: { linkage: "Liaison du client", fields: "Écarts de champs", identity: "Identité du client",
            contact: "Contact commercial", address: "Adresse", unresolved: "Sources indéterminées" },
        fields: { companyName: "Nom du client", organizationNumber: "Numéro d'organisation",
            sellerEmail: "E-mail du vendeur", csn: "Numéro client Autodesk (CSN)", visitingCity: "Ville de visite (SF / WK Place)",
            postalAddress: "Adresse postale", postalCity: "Ville postale", postalCode: "Code postal",
            country: "Pays (code SF / ID pays WK)", countryUnrecognized: "Code pays (non reconnu dans SF)" },
        checks: {
            linkage: "Vérifier les numéros clients et les doublons avant d'associer les clients ou de corriger les champs.",
            identity: "Vérifier le nom et le numéro d'organisation par rapport aux informations enregistrées.",
            csn: "Vérifier les deux numéros Autodesk par rapport au bon compte client.",
            contact: "Vérifier l'e-mail du propriétaire Account SF par rapport au contact commercial WK.",
            visitingCity: "Vérifier la ville de visite SF (VisitingAddress__City__s) par rapport à WK Place. BillingCity est utilisé uniquement pour la ville postale.",
            address: "Vérifier l'adresse postale du client des deux côtés.",
            country: "SF utilise un code ISO, WK un identifiant pays numérique. Vérifier le pays représenté, pas l'égalité des valeurs brutes.",
            unknownField: "Ce champ n'est pas associé dans l'affichage. Vérifier les valeurs brutes et la correspondance avant correction.",
        },
        accounts: "Comptes",
        assets: "Assets",
        contracts: "Contrats",
        contractLoadError: "Impossible de charger la comparaison des contrats.",
        fetch: "Charger les comparaisons sélectionnées",
        results: "Résultats des comparaisons",
        assetLoadError: "Impossible de charger la comparaison des Assets. Aucune liste complète n'est disponible.",
        loading: "Chargement de la comparaison",
        loadError: "Impossible de charger la comparaison des comptes. Aucune liste complète n'est disponible.",
        incomplete: "La comparaison est incomplète. Cette liste peut ne pas contenir tous les écarts.",
        deferredAccountFields: "Le code payeur StarterMap, les champs d'adresse supplémentaires et les champs de compte renseignés uniquement à la création ne sont pas encore comparés.",
        noDifferences: "Aucun écart trouvé.",
        salesforceId: "ID Salesforce",
        webkuaId: "ID WebKUA",
        status: "Statut",
        field: "Champ",
        salesforceValue: "Valeur Salesforce",
        webkuaValue: "Valeur WebKUA",
        UnmatchedSalesforce: "Numéro client WebKUA absent dans Salesforce",
        MissingInWebkua: "Absent dans WebKUA",
        MissingInSalesforce: "Absent dans Salesforce",
        DuplicateCompanyNumber: "Numéro client en double - correspondance ambiguë",
        FieldMismatch: "Valeurs différentes",
    },
    salesForceContractReconciliation: {
        sync: {
            column: "Action", button: "Sync SF → WK", savedButton: "Commande enregistrée",
            title: "Synchroniser le contrat {{number}} de SF vers WK",
            tooltip: "Champs à synchroniser de SF vers WK : {{fields}}.",
            unsupportedFields: "Synchronisation impossible : {{fields}} ne sont pas pris en charge.",
            emptyFields: "Synchronisation impossible : {{fields}} manquent dans SF et ne peuvent pas être effacés dans WK.",
            inactiveSource: "Synchronisation impossible : le contrat n'est pas actif dans {{system}}.",
            todayEndDate: "Synchronisation impossible : la date de fin est aujourd'hui et modifierait l'activité dans WK.",
            linkNumber: "Synchronisation impossible : le lien du numéro de contrat est manquant ou différent.",
            customerLink: "Synchronisation impossible : le lien client manque ou les clients diffèrent.",
            sourceLink: "Synchronisation impossible : un lien vers une source manque.",
            unsupportedKind: "Synchronisation impossible : {{kind}}.",
            description: "Cette action envoie la commande existante avec les valeurs SF affichées. Les autres champs sont conservés. Le contrat est vérifié avant l'envoi, mais la commande peut créer un contrat si le lien WK disparaît avant l'exécution.",
            preview: "Écarts actualisés avant synchronisation", loading: "Vérification ou envoi de la commande …",
            confirm: "Confirmer et envoyer", close: "Fermer", newPreview: "Obtenir un nouvel aperçu",
            retry: "Vérifier le même envoi", refresh: "Vérifier le rapport à nouveau",
            submitted: "La commande a été envoyée. La synchronisation n'est pas confirmée terminée. Vérifiez son statut et rechargez le rapport après exécution.",
            recorded: "La commande est déjà enregistrée et n'a pas été renvoyée. Vérifiez son statut ; l'exécution n'est pas confirmée ici.",
            orderId: "ID de commande : {{id}}",
            errors: {
                InvalidPreview: "La confirmation est expirée ou invalide. Obtenez un nouvel aperçu.",
                SourceChanged: "Les données SF ou WK ont changé depuis l'aperçu. Obtenez un nouvel aperçu.",
                AmbiguousLink: "La synchronisation exige un contrat dans chaque système, le même client et des numéros et identifiants sources non ambigus.",
                NoDifferences: "Aucun écart ne peut être corrigé par cette action. Les avertissements de date/statut seuls ne peuvent pas être synchronisés.",
                UnsupportedDifference: "La commande ne peut pas corriger tous les écarts. Le début, l'intervalle, le client facturé et les changements d'activité ne sont pas pris en charge. Une fin aujourd'hui modifierait aussi l'activité.",
                UnsafeSource: "Les données sources sont incomplètes, ou le statut SF et les dates sont incohérents. Vérifiez les détails.",
                EmptySource: "La commande ne peut pas effacer les champs WK. Les valeurs SF manquantes empêchent donc la synchronisation.",
                OperatorUnresolved: "L'utilisateur connecté ne correspond pas de façon unique à un utilisateur WK.",
                PendingOrder: "Une commande de mise à jour du contrat est déjà ouverte. Vérifiez-la avant un nouvel envoi.",
                OrderConflict: "Une commande existante n'a pas pu être associée sûrement à cette action. Vérifiez-la.",
                DispatchFailed: "La commande est enregistrée, mais son envoi n'est pas confirmé. Vérifiez-la avant un nouvel envoi.",
                RequestFailed: "La requête n'a pas pu être confirmée. La commande peut déjà être enregistrée. Vérifiez le même envoi ou son statut avant un nouvel envoi."
            }
        },
        sourcePresence: "Trouvé dans", mainFinding: "Constat principal", allFindings: "Tous les constats",
        comparisonKind: "Type d'écart", sfLinkKey: "Numéro de liaison SF enregistré dans WK",
        presence: { both: "SF et WK", salesforceOnly: "SF uniquement", webkuaOnly: "WK uniquement", neither: "Aucune source" },
        multipleMatches: "Plusieurs correspondances possibles", sourceEvidence: "Afficher les informations sources",
        nextCheck: "À vérifier", moreFindings_one: "1 autre constat", moreFindings_other: "{{count}} autres constats",
        notFound: "Non trouvé", notCompared: "Non comparé", notReported: "Non renseigné",
        noTerminationDate: "Aucune date de résiliation", unknown: "Indéterminé",
        noFindingDetails: "Aucune raison précise fournie. Vérifier les informations sources.",
        missingLinkKey: "Numéro de contrat SF absent. La liaison ne peut pas être vérifiée.",
        notFoundInSalesforce: "Le contrat WK n'a pas été trouvé dans SF avec ce numéro de liaison.",
        notFoundInWebkua: "Le contrat SF n'a pas été trouvé dans WK avec ce numéro de contrat.",
        ambiguousSources: "Plusieurs contrats possibles : {{sf}} dans SF et {{wk}} dans WK.",
        sourceIssue: "{{system}} : {{issue}}", unattributedIssue: "Côté source non précisé : {{issue}}",
        activityFinding: "SF : {{sf}} · WK : {{wk}}", customerFinding: "Client différent : SF {{sf}} · WK {{wk}}",
        fieldFinding: "{{field}} diffère.",
        laggingWebkua_one: "WK a une période de facturation de retard sur SF.",
        laggingWebkua_other: "WK a {{count}} périodes de facturation de retard sur SF.",
        laggingSalesforce_one: "SF a une période de facturation de retard sur WK.",
        laggingSalesforce_other: "SF a {{count}} périodes de facturation de retard sur WK.",
        filteredRows: "{{shown}} lignes affichées sur {{total}}.", clearFilters: "Réinitialiser les filtres de constats",
        filters: { linkage: "Liaison du contrat", activity: "Statut actif", renewal: "Renouvellement",
            fields: "Autres champs", unresolved: "Sources indéterminées", warningsOnly: "Avertissements uniquement" },
        findingRules: "Trouvé dans indique les sources réellement récupérées. Un numéro SF enregistré dans WK ne prouve pas l'existence du contrat SF. Un numéro de liaison absent signifie que l'autre côté n'a pas été comparé. Les constats peuvent se chevaucher ; tous les filtres sélectionnés doivent correspondre. Les vérifications ne désignent pas le côté correct. Le périmètre SF inclut les Accounts avec un numéro client WebKUA.",
        checks: {
            customerLink: "Vérifier le numéro de contrat SF, le client et la liaison WK avant de corriger les valeurs.",
            activity: "Vérifier le statut SF et EndDate par rapport à la résiliation et l'arrêt de maintenance WK.",
            renewal: "Vérifier l'historique de renouvellement et les intervalles des deux côtés avant de corriger les dates.",
            dates: "Vérifier les dates par rapport à la période contractuelle convenue.",
            billing: "Vérifier le client facturé et les informations de facturation dans SF et WK.",
            interval: "Vérifier l'intervalle de facturation par rapport au contrat.",
            contact: "Vérifier Bill-to Contact dans SF et le responsable dans WK.",
            sourceData: "Clarifier les informations absentes ou invalides dans la source indiquée avant correction.",
        },
        contract: "Contrat", company: "Client", sfContract: "Contrat SF", wkContract: "Contrat WK",
        status: "Écart", changedFields: "Champs différents", field: "Champ", sfValue: "Valeur SF", wkValue: "Valeur WK",
        issuesTitle: "Sources non résolues", differences: "Différences de champs", noSource: "Aucun contrat lié.",
        current: "Actif", ended: "Inactif",
        counts: "{{inSync}} contrats sur {{compared}} comparés de manière fiable sont synchronisés.",
        noDifferences: "Aucun écart de contrat dans le périmètre comparé.",
        about: "À propos de la comparaison des contrats",
        scope: "Les contrats en cours sur au moins un côté, d'activité inconnue ou de statut SF incohérent sont inclus. Les autres contrats terminés sont exclus. Les numéros SF exacts relient les contrats même si les clients diffèrent.",
        dateRules: "Seul le statut SF Activated peut être actif ; les autres statuts renseignés sont inactifs et un statut absent est indéterminé. Les dates sont comparées sans heure. EndDate SF est le dernier jour valide. WK utilise la résiliation et l'arrêt de maintenance ; un écart d'activité ce jour-là peut donc être attendu.",
        renewalRules: "NextRenewDate__c SF est comparée à NextInvoicingDate WK. Pour une paire active non ambiguë du même client avec des intervalles de facturation valides identiques, la date antérieure est indiquée comme non renouvelée si l'écart est un multiple entier exact de l'intervalle en mois calendaires. Les autres écarts restent des dates différentes. Cette évaluation repose sur les dates, sans confirmer un succès ou un échec du renouvellement. Toute date avant le jour de comparaison (UTC) reçoit une icône d'avertissement quel que soit le statut actif. L'icône indique seulement que la date est passée. Les contrats actifs aux dates identiques dépassées apparaissent également comme lignes d'avertissement.",
        notRenewedInWebkua: "Non renouvelé dans WK", notRenewedInSalesforce: "Non renouvelé dans SF",
        renewalAssessment: "Évaluation du renouvellement", differentRenewalDates: "Dates de renouvellement différentes",
        matchingRenewalDates: "Dates de renouvellement identiques", renewalUnresolved: "Dates de renouvellement non comparables de manière fiable",
        billingMappings: "Le responsable est comparé à Bill_to_Contact__r.Email. Le client facturé est comparé à BillToAccount__r.WebKuaCustomerNumber__c. WK utilise le numéro du client facturé, ou celui du contrat si le numéro de facturation est vide. Des informations de facturation absentes restent indéterminées. Le vendeur n'est pas comparé.",
        warningsTitle: "Avertissements",
        warnings: { ExpiredWithoutEndDate: "Le statut SF est Expired, mais EndDate est absente.",
            ExpiredWithCurrentEndDate: "Le statut SF est Expired, mais EndDate est aujourd'hui ou dans le futur.",
            ActivatedWithPastEndDate: "Le statut SF est Activated, mais EndDate est passée.",
            SalesforceRenewalDatePassed: "Date de renouvellement dépassée dans SF",
            WebkuaRenewalDatePassed: "Date de renouvellement dépassée dans WK" },
        orderLimitations: "La synchronisation exige un aperçu et une confirmation et n'est proposée que si la commande peut corriger tous les écarts. Le début, l'intervalle, le client facturé, les changements d'activité et l'effacement des champs ne sont pas pris en charge pour les contrats existants.",
        kinds: { MissingKey: "Numéro de contrat SF absent", AmbiguousContract: "Plusieurs contrats avec le même numéro SF",
            MissingInSalesforce: "Contrat uniquement dans WK", MissingInWebkua: "Contrat uniquement dans SF",
            ComparisonBlocked: "Sources de contrat non résolues", CompanyMismatch: "Client différent", ActivityMismatch: "Statut actif différent",
            FieldMismatch: "Champs de contrat différents", SourceWarning: "Statut SF incohérent", RenewalWarning: "Date de renouvellement dépassée" },
        fields: { companyNumber: "Numéro client", isCurrent: "Statut actif", startDate: "Date de début",
            nextRenewalDate: "Prochain renouvellement", terminationDate: "Date de résiliation", maintenanceStopDate: "Arrêt de maintenance",
            currency: "Devise", invoiceInterval: "Intervalle de facturation (mois)", invoicedCompanyNumber: "Numéro du client facturé",
            contractResponsibleEmail: "Responsable (email)", status: "Statut SF" },
        issues: { MissingContractNumber: "Numéro de contrat SF absent.", MissingCompanyNumber: "Numéro client absent.",
            MissingContractInfo: "Informations du contrat WK absentes.", UnknownActivity: "Activité du contrat non résolue.",
            MissingStartDate: "Date de début absente.", MissingNextRenewalDate: "Prochain renouvellement absent.",
            InvalidInvoiceInterval: "Intervalle de facturation absent ou invalide.", MissingCurrency: "Devise absente.",
            MissingInvoiceInfo: "Informations de facturation WK absentes.", MissingInvoicedCompanyNumber: "Numéro du client facturé absent." },
    },
    reconciliationFilters: {
        syncFilter: "Synchronisation", categoryFilter: "Contrôle", all: "Tous", canSync: "Synchronisables",
    },
    salesforceInternal: {
        tab: "SF interne",
        requiresAll: "Chargez les comptes, assets et contrats. Les trois chargements doivent être terminés pour ouvrir SF interne.",
        missingEvidence: "Les données sources SF sont absentes. Mettez à jour l'API et rechargez les trois comparaisons.",
        scope: "Contrôles SF en lecture seule pour les clients liés à WK dans la comparaison NO actuelle. Les clients internes/de test et produits d'offre sont exclus. Les contrats sont des abonnements et l'annulation est immédiate. Les contrats actifs doivent avoir des assets récurrents actifs avec la même date de fin. Le support et les achats ponctuels sont exclus des contrôles de cycle de vie. Les écarts au renouvellement du contrat sont des avertissements ; les dates de fin différentes entre assets actifs sont des erreurs.",
        snapshots: "Assets chargés : {{assets}}. Contrats chargés : {{contracts}}. Les lectures sont séparées ; des changements SF intermédiaires peuvent créer des écarts temporaires. La date d'évaluation suit la lecture des contrats.",
        noFindings: "Aucun résultat pour les contrôles implémentés sur les données chargées. Ce n'est pas une validation complète de Salesforce.",
        severityFilter: "Gravité", ruleFilter: "Contrôle", all: "Tous",
        severity: { error: "Erreur", warning: "Avertissement", unevaluable: "Impossible à évaluer" },
        sameEndDate: "Même date de fin pour les assets actifs",
        columns: { severity: "Gravité", rule: "Constat", company: "Numéro client", contractNumber: "Contrat SF",
            asset: "Asset", productCode: "Code produit", assetStatus: "Statut asset", contractStatus: "Statut contrat",
            usageEnd: "Fin asset", contractEnd: "Fin contrat", renewal: "Prochain renouvellement",
            quantity: "Quantité asset", cancellation: "Date d'annulation",
            installDate: "Date d'installation asset", contractStart: "Début du contrat",
            actual: "Valeur actuelle", expected: "Référence / valeur attendue" },
        rules: {
            IncompleteAssetEvidence: "Champs SF sélectionnés absents de la réponse asset",
            UnknownAssetStatus: "Statut asset non interprétable", UnknownRecurrence: "Récurrence produit non résolue",
            MissingContract: "Asset récurrent actif sans contrat", ContractNotFetched: "Contrat absent du périmètre chargé",
            AmbiguousContract: "Plusieurs contrats chargés ont le même ID SF", MissingAccount: "ID compte absent sur l'asset ou le contrat",
            AccountMismatch: "Asset et contrat liés à des comptes SF différents", UnknownContractStatus: "Statut contrat non interprétable",
            InvalidDate: "Date SF non interprétable", ActiveOnCancelledContract: "Asset actif sur contrat annulé",
            ActiveOnExpiredContract: "Asset actif sur contrat expiré", ActiveOnDraftContract: "Asset actif sur contrat brouillon",
            ActiveOnPastEndedContract: "Asset actif sur contrat dont la fin est passée",
            UsageBeyondContractEnd: "Fin asset après la fin du contrat",
            MissingUsageEnd: "Asset récurrent actif sans date de fin", PastUsageEnd: "Asset actif dont la fin est passée",
            MissingRenewalDate: "Prochain renouvellement requis pour ce contrôle",
            RenewalMisalignment: "Fin asset différente de la veille du prochain renouvellement",
            ActiveContractWithoutAssets: "Contrat d'abonnement actif sans assets récurrents actifs",
            IncompleteContractAssets: "Données assets incomplètes empêchant l'évaluation du contrat",
            ActiveAfterCancellation: "Asset encore actif à partir de sa date d'annulation",
            InconsistentAssetEndDates: "Assets actifs d'un contrat avec des dates de fin différentes",
            ActivatedWithPastEndDate: "Contrat activé avec une date de fin passée",
            ExpiredWithoutEndDate: "Contrat expiré sans date de fin",
            ExpiredWithCurrentEndDate: "Contrat expiré avec une fin aujourd'hui ou dans le futur",
            SalesforceRenewalDatePassed: "Contrat actif avec une date de renouvellement passée",
            InvalidQuantity: "Asset de licence actif avec une quantité absente ou invalide",
            ActiveZeroQuantity: "Asset de licence actif avec une quantité nulle",
            ContractEndBeforeStart: "Fin du contrat avant son début",
            ContractRenewalBeforeStart: "Renouvellement du contrat avant son début",
            MissingContractIdentity: "Contrat sans ID SF",
            IncompleteLifecycleEvidence: "Champs de date ou d'annulation absents de la réponse asset",
            AssetStartAfterEnd: "Installation de l'asset après sa date de fin",
            ActiveOnFutureContract: "Asset actif sur un contrat dont le début est futur",
            CancellationBeforeAssetStart: "Annulation de l'asset avant son installation",
            CancelledWithoutCancellationDate: "Asset récurrent annulé sans date d'annulation",
        },
    },
    salesForceMetadata: {
        title: "Métadonnées Salesforce",
        object: "Type d'objet",
        fetch: "Charger les métadonnées",
        loading: "Chargement des métadonnées des champs Salesforce...",
        error: "Impossible de charger les métadonnées des champs Salesforce.",
        loaded: "{{objectName}} : {{count}} champs",
        name: "Nom du champ",
        label: "Libellé",
        type: "Type du champ",
        referenceTo: "Références",
        relationshipName: "Nom de la relation",
    },
    salesForceAssetReconciliationSync: {
        field: "Champ", salesforceValue: "Quantité SF", webkuaValue: "Quantité WK", fields: { quantity: "Quantité" },
        sync: {
            column: "Action", button: "Sync SF → WK", warningButton: "Sync SF → WK (attention)",
            savedButton: "Commande enregistrée", title: "Synchroniser {{number}} de SF vers WK",
            tooltip: "Champs à synchroniser de SF vers WK : {{fields}}.",
            description: "Envoie une commande Asset avec la quantité prévisualisée. Une quantité active uniquement dans WK entraîne une résiliation ; uniquement dans SF, une création dans WK. Le lien est contrôlé avant l'envoi mais peut changer avant l'exécution.",
            actions: {
                Update: "Met à jour la quantité de la ligne existante. La remise et les autres champs sont conservés.",
                Stop: "Résilie la ligne existante avec une quantité de 0. La licence est aussi résiliée si aucun poste actif ne reste.",
                CreateLicense: "Crée une nouvelle licence WK avec la quantité et la remise de SF.",
                CreateItem: "Crée une nouvelle ligne sur la licence WK existante avec la quantité et la remise de SF."
            },
            usedWarning: "Attention : la licence a été utilisée en 2026, dernièrement le {{date}}. La synchronisation résilie la ligne et peut supprimer un accès encore utilisé.",
            reduceWarning: "La quantité passe de {{from}} à {{to}}. Cela réduit les postes sans résilier la ligne.",
            stopWarning: "La quantité passe de {{from}} à 0. La ligne est résiliée. La licence est également résiliée si aucun poste actif ne reste.",
            preview: "Écart de quantité actualisé", loading: "Vérification ou envoi de la commande …",
            confirm: "Confirmer et envoyer", close: "Fermer", newPreview: "Obtenir un nouvel aperçu",
            retry: "Vérifier le même envoi", refresh: "Vérifier le rapport à nouveau",
            submitted: "La commande a été envoyée. L'exécution n'est pas confirmée. Vérifiez son statut et rechargez le rapport après exécution.",
            recorded: "La commande est déjà enregistrée et n'a pas été renvoyée. Vérifiez son statut.",
            orderId: "ID de commande : {{id}}",
            errors: {
                InvalidPreview: "La confirmation est expirée ou invalide. Obtenez un nouvel aperçu.",
                SourceChanged: "Les données SF, WK ou produit ont changé. Obtenez un nouvel aperçu.",
                AmbiguousLink: "Synchronisation impossible : le lien client, contrat ou ligne n'est pas unique.",
                NoDifferences: "Aucun écart de quantité à synchroniser. Rechargez le rapport.",
                MultipleTargets: "Synchronisation impossible : plusieurs licences ou lignes peuvent être sélectionnées. Une correction manuelle est requise.",
                DiscountUnsupported: "Synchronisation impossible : cette action ne corrige pas les écarts ou répartitions de remise.",
                ProductUnresolved: "Synchronisation impossible : la correspondance produit est manquante ou ambiguë.",
                InactiveTarget: "Synchronisation impossible : la ligne choisie est résiliée, ou aucune ligne active ne peut être résiliée. La commande ne réactive pas les lignes résiliées.",
                ParentUnresolved: "Synchronisation impossible : le module nécessite une licence principale active unique sur le même contrat.",
                UnsafeSource: "Synchronisation impossible : la quantité, le statut ou le produit SF est indéterminé.",
                UnsafeTarget: "Synchronisation impossible : les données produit, remise ou postes WK sont invalides.",
                InvalidQuantity: "Synchronisation impossible : la quantité doit être un entier entre 0 et 2147483647.",
                IncompleteSource: "Synchronisation impossible : des informations sources ou cibles manquent. Rechargez le rapport.",
                UnsupportedDifference: "Synchronisation impossible : cet écart ne peut pas être corrigé par une commande de quantité, de résiliation ou de création.",
                OperatorUnresolved: "L'utilisateur connecté ne correspond pas de façon unique à un utilisateur WK.",
                PendingOrder: "Synchronisation impossible : une commande Asset pour le même contrat et article est déjà ouverte.",
                OrderConflict: "Une commande existante n'a pas pu être associée sûrement à cette action. Vérifiez-la.",
                DispatchFailed: "La commande est enregistrée, mais son envoi n'est pas confirmé. Vérifiez-la avant un nouvel envoi.",
                RequestFailed: "La requête n'a pas pu être confirmée. La commande peut déjà être enregistrée. Vérifiez le même envoi ou son statut avant un nouvel envoi."
            }
        }
    },
    salesForceAssetReconciliation: {
        contracts: "Contrat",
        item: "Article",
        sfQuantity: "Qté SF",
        wkQuantity: "Qté WK",
        renewal: "Expiration / renouvellement",
        usage: "Utilisation (2026)",
        sync: "Synchro",
        chooseAssets: "Choisir un Asset Salesforce",
        assetChoice: "{{number}}. {{name}} - {{status}}, quantité {{quantity}}, expiration {{date}}",
        otherContractBadge: "Contrat possiblement incorrect",
        afterRenewalBadge: "Après renouvellement",
        renewalUseUnknown: "Utilisation enregistrée, mais date de renouvellement absente ou ambiguë",
        syncPlanned: "Prévu",
        syncOverdue: "En retard, ouvert",
        syncSummary: "{{state}} : {{quantity}} / {{date}}",
        pendingUnknown: "Commande ouverte, résumé inconnu",
        quickFilters: "Filtres rapides",
        clearFilters: "Réinitialiser les filtres",
        showDiscount: "Afficher la remise",
        filteredRows: "{{shown}} lignes affichées sur {{total}}",
        salesforceUsageEndDates: "Date de fin de l'article Salesforce (UsageEndDate)",
        dateSources: "SF : date de fin de l'article (UsageEndDate). WK : prochain renouvellement du contrat.",
        aboutComparison: "À propos de la comparaison",
        detailsQuantityMismatch: "Quantités actives différentes : SF {{sfQuantity}}, WK {{wkQuantity}}.",
        detailsSfOnly: "{{sfQuantity}} actifs dans Salesforce – aucune ligne WK active sur ce contrat.",
        detailsWkOnly: "{{wkQuantity}} actifs dans WebKUA – aucun Asset SF actif sur ce contrat.",
        sourceEndDate: "Date de fin (SF)",
        sourceContractRenewal: "Renouvellement du contrat (WK)",
        noActiveSourceAssets: "Aucun Asset SF actif sur ce contrat.",
        noActiveSourceItems: "Aucune ligne WK active sur ce contrat.",
        candidateEvidenceOnly: "Candidats, pas de correspondance certaine.",
        sourceSummary: "{{sfCount}} Assets SF et {{wkCount}} lignes WK. Quantités actives affichées : SF {{sfQuantity}}, WK {{wkQuantity}}.",
        quantityExplanation: "SF additionne Quantity des Assets Active, pas Renewal Quantity. Les Assets Inactive et Cancelled sont exclus du rapprochement des produits. WK est contrôlé indépendamment et additionne les lignes dont la licence et la ligne sont actives. Les liens non résolus ne sont pas comparés de manière fiable.",
        discountAllocation: "Répartition des remises",
        productMatchIssue: "Correspondance de l'article",
        productCandidates: "Articles WK possibles pour le code produit SF",
        productCandidatesExplanation: "Ces candidats concernent le même client et contrat, sans correspondance certaine. Les quantités ne servent pas à choisir l'article.",
        UnknownProductCode: "Le code produit SF n'a aucun article WK connu",
        AmbiguousProductCode: "Le code produit SF correspond à plusieurs articles WK possibles",
        identifiedItemMissingCounterpart: "L'article est identifié pour ce client et contrat. Un seul côté possède une contrepartie active. - indique une source absente, pas une correspondance non résolue.",
        noMatchedSourceItems: "Aucune ligne WK appariée avec certitude.",
        companyComparisonTitle: "Même client et article entre contrats",
        netDifference: "Différence nette de quantité (SF − WK)",
        netDiscountDifferences: "Différence nette par remise (SF − WK)",
        discrepanciesOnly: "Seuls les écarts entre contrats sont affichés, pas les quantités totales de l'entreprise. Les contrats synchronisés contribuent zéro et sont omis. L'absence certaine d'un article compte comme 0 dans la différence, mais reste affichée par -.",
        companyComparison: {
            ContractDistributionMismatch: "Quantités et remises se compensent – répartition entre contrats différente",
            QuantityBalancedDiscountMismatch: "Quantités équilibrées – répartition globale des remises différente",
            QuantityMismatch: "Quantités nettes différentes",
            DiscountMismatch: "Répartition globale des remises différente",
            ComparisonBlocked: "Comparaison entre contrats non résolue",
        },
        discountPrecision: "Les quantités sont comparées par remise arrondie à {{decimals}} décimales. Les licences réparties sont acceptées si les répartitions correspondent. Une remise SF vide signifie 0%. Une remise WK absente ou une remise invalide reste non résolue.",
        unknownDiscount: "Remise non résolue",
        discountGroupSummary: "{{discount}} : SF {{sfQuantity}}, WK {{wkQuantity}}",
        DiscountMismatch: "Même quantité totale, mais quantités différentes par remise",
        DiscountComparisonBlocked: "Répartition non comparable de manière fiable : remise absente/invalide ou quantité active négative",
        sourceDetailsUnavailable: "Les détails sources sont absents de la réponse API. Recompilez et redémarrez l'API, puis rechargez.",
        noSourceAssets: "Aucune source Salesforce dans cette ligne.",
        noSourceItems: "Aucune source WebKUA dans cette ligne.",
        sourceAsset: "Asset / code produit",
        sourceStatus: "Statut",
        sourceQuantity: "Quantité",
        sourceActiveQuantity: "Quantité active",
        renewalQuantity: "Quantité de renouvellement",
        excludedFromRenewal: "Exclu du renouvellement",
        cancellation: "Annulation",
        sourceActive: "Actif",
        sourceInactive: "Inactif",
        sourceLicense: "Licence",
        sourceItem: "Ligne d'article",
        sourceDiscount: "Remise (%)",
        sourceDates: "Résiliation / expiration",
        sourceMaintenance: "Maintenance",
        sourceRenewal: "Renouvellement",
        noUsage2026: "Aucune utilisation enregistrée en 2026",
        usageIsLicenseLevel: "L'utilisation concerne la licence, pas nécessairement cet article. Une utilisation après renouvellement ne prouve pas une facturation manquante.",
        oneTimeExcluded: "Article ponctuel - exclu du rapprochement",
        filters: {
            afterRenewal: "Utilisé après renouvellement",
            recent: "Utilisé depuis moins de 30 jours",
            otherContract: "Contrat possiblement incorrect",
            contractDistribution: "Écarts compensés entre contrats",
            discountMismatch: "Répartition des remises différente",
            pending: "Synchronisation ouverte",
            unresolved: "Comparaison non résolue",
            sfZeroWkPositive: "SF = 0, WK > 0",
        },
        compactStatus: {
            wkOnlyActive: "Quantité active uniquement dans WK",
            sfOnlyActive: "Quantité active uniquement dans SF",
            MissingInWebkua: "Quantité active uniquement dans SF",
            MissingInSalesforce: "Quantité active uniquement dans WK",
            UnknownProductCode: "Code produit SF inconnu",
            AmbiguousProductCode: "Code produit SF ambigu",
            QuantityMismatch: "Quantité différente",
            DiscountMismatch: "Répartition des remises différente",
            DiscountComparisonBlocked: "Répartition des remises non résolue",
            DuplicateWebkuaLicenses: "Même quantité, plusieurs licences",
            ComparisonBlocked: "Lien non résolu",
            UnmappedWebkuaItem: "Article WK non résolu",
            UnmappedProduct: "Article inconnu/ambigu",
            MissingKey: "Clé de correspondance manquante",
            UnclassifiedAsset: "Statut/quantité SF inconnu",
            AmbiguousContract: "Contrat ambigu",
        },
        inSyncGroups: "{{inSync}} groupes client–contrat–article sur {{compared}} comparés de manière fiable ont des quantités et répartitions de remises identiques.",
        noComparableGroups: "0 groupe sur 0 synchronisé : aucun groupe client–contrat–article n'a pu être comparé de manière fiable.",
        pendingOrders: "{{count}} commandes Asset sont en attente dans WebKUA. Elles ne sont pas incluses dans les quantités de licences actuelles.",
        pendingOrderId: "ID de commande",
        hasPendingOrders: "Synchronisation ouverte",
        latestPendingQuantity: "Dernière quantité prévue",
        latestPendingActivationDate: "Dernière synchronisation prévue le",
        latestPendingUnresolved: "La dernière commande de synchronisation ouverte n'a pas pu être déterminée pour les lignes client/contrat/article suivantes. Leur quantité cible et leur date ne sont pas affichées :",
        webkuaContractNumber: "Numéro de contrat WebKUA",
        webkuaContractRenewalDates: "Date de renouvellement WebKUA",
        pendingQuantity: "Quantité prévue",
        activationDate: "Activation prévue",
        deferredAssetFields: "Les quantités actives et répartitions des remises avec une correspondance fiable sont comparées. Les contrats non liés, les statuts ou produits inconnus, les Assets historiques et les autres champs restent non rapprochés.",
        contractNumber: "Numéro de contrat Salesforce",
        productCode: "Code produit Salesforce",
        salesforceDiscount: "Remise SF (%)",
        lastUsedDate2026: "Dernière date d'utilisation enregistrée dans WebKUA (2026)",
        usedAfterRenewalDate: "Utilisé après la date de renouvellement (2026)",
        otherWebkuaContracts: "Article actif sur d'autres contrats WebKUA (correspondances possibles)",
        otherContractItem: "{{contractNumber}} : {{quantity}} (licence {{licenseNumbers}})",
        candidateContracts: "Contrats SF possibles (client/article seulement)",
        itemId: "ID d'article",
        salesforceActiveQuantity: "Quantité active Salesforce",
        webkuaActiveQuantity: "Quantité active WebKUA",
        salesforceAssetIds: "ID des Assets Salesforce",
        webkuaLicenseNumbers: "Numéros de licence WebKUA",
        duplicateWebkuaLicenseNumbers: "Plusieurs licences WebKUA actives (information)",
        DuplicateWebkuaLicenses: "Même quantité répartie entre plusieurs licences WebKUA actives ; ancien résultat sans comparaison des remises",
        licenseTerminationDates: "Date de résiliation de licence (par nº)",
        maintenanceExpirationDates: "Date d'expiration de maintenance (par nº)",
        itemTerminationDates: "Date de résiliation d'article (par nº)",
        webkuaContractIds: "ID des contrats WebKUA",
        AmbiguousContract: "Plusieurs contrats WebKUA partagent le numéro Salesforce – articles non comparés",
        UnmappedProduct: "Produit inconnu ou ambigu",
        MissingKey: "Numéro client ou contrat manquant",
        UnclassifiedAsset: "Statut ou quantité Asset non classé",
        UnmappedWebkuaItem: "Article WebKUA sans lien fiable vers le client, le contrat ou l'article",
        MissingInWebkua: "SF possède une quantité active ; WK n'a aucune ligne active pour ce client, contrat et article",
        MissingInSalesforce: "WK possède une quantité active ; SF n'a aucun Asset actif pour ce client, contrat et article",
        ComparisonBlocked: "Lien non résolu : quantités connues uniquement, non comparées",
        ActivationMismatch: "Un seul côté possède une quantité active",
        QuantityMismatch: "Quantités actives différentes",
    },
    salesForceAssetSync: {
        itemId: "ID Webkua",
        licenseCount: "Articles dans Webkua",
        orderCount: "Commandes en attente",
        oldQuantity: "Quantité dans Webkua",
        newQuantity: "Nouvelle quantité",
        contractRenewalDate: "Date de renouvellement du contrat",
        syncing: "Synchronisation enregistrée",
        manuallyHandled: "Géré manuellement",
        setAsManuallyHandled: "Marquer comme géré manuellement",
        sync: "Synchroniser",
    },
    "headerBar": {
        "yourUserSettings": "Vos paramètres utilisateur",
        "logOut": "Se déconnecter"
    },
    "mainMenu": {
        licensing: "Gestion des licences",
        administration: "Administration",
        troubleshooting: "Dépannage",
        courseAdministration: "Cours",
        showHiddenItems: "Afficher les éléments masqués",
        "navigation": "Navigation"
    },
    "companyDialog": {
        "companyIsCreated": "Entreprise créée.",
        "couldNotCreateCompany": "Impossible de créer l'entreprise.",
        "requestDenied": "Demande refusée.",
        "couldNotDeclineRequest": "Impossible de refuser la demande."
    },
    "companyRequest": {
        "requests": "Demandes",
        "userAddedInfo": "Infos ajoutées par l'utilisateur",
        "isForeign": "Entreprise étrangère",
        "country": "Pays",
        "status": "Statut",
        "DoesNotExist": "Le numéro d'organisation n'existe pas dans Superoffice",
        "ExistsInCRM": "Le numéro d'organisation existe dans Superoffice",
        "ExistsInWebkua": "Le numéro d'organisation existe dans Webkua",
        "companiesOutsideBrønnøysund": "Entreprises en dehors de Brønnøysund",
        "followUpSellerName": "Nom du vendeur de suivi",
        "chooseFollowUpSeller": "Choisir le vendeur de suivi",
    },
    "futureRenewals": {
        "futureRenewals": "Renouvellements futurs"
    },
    "orders": {
        "orders": "Commandes"
    },
    "autodeskOpportunities": {
        "address": "Adresse",
        "csn": "CSN",
        "companyName": "Nom de l'entreprise",
        "companyNumber": "Numéro d'entreprise",
        "contractManagerEmail": "Email du responsable de contrat",
        "contractManagerName": "Nom du responsable de contrat",
        "status": "Statut",
        "quantity": "Quantité",
        "costPrice": "Prix coûtant",
        "purPriceEur": "Prix d'achat EUR",
        "renewalSkus": "SKUs de renouvellement",
        "skuDescriptions": "Descriptions des SKU",
        "endDate": "Date de fin",
        "renewalSku": "SKU de renouvellement",
        "skuDescription": "Description du SKU",
        "hasExistingOrder": "Possède une commande existante",
        "createOrder": "Créer une commande",
    },
    "autodeskCatalog": {
        "title": "Catalogue Autodesk",
        "subtitle": "Choisissez les produits Autodesk à créer dans Webkua",
        "private": "Privé (Agency)",
        "product": "Produit",
        "code": "Code",
        "sellable": "Vendables",
        "status": "Statut",
        "imported": "Créé",
        "select": "Sélectionner",
        "selected": "Sélectionné",
        "update": "Mettre à jour",
        "updated": "mis à jour",
        "createProducts": "Créer/mettre à jour les produits",
        "term": "Durée",
        "orderAction": "Type",
        "newSale": "Nouvelle vente",
        "renewal": "Renouvellement",
        "quantity": "Quantité",
        "servicePlan": "Plan de service",
        "discountProgram": "Programme de remise",
        "priceAfterDiscounts": "Prix après remise",
        "specialPrograms": "Programmes de remise",
        "description": "Description",
        "noVariants": "Aucun programme de remise",
        "programs": "Programmes",
        "products": "produits",
        "priceMismatches": "Écarts de prix",
        "renewalOnly": "Renouvellement seul",
        "setupId": "ID nouvelle vente",
        "recurringId": "ID renouvellement",
        "blocked": "Ne peut pas être créé",
        "priceDrift": "Changement de prix",
        "created": "créés",
        "skipped": "ignorés",
        "priceDifference": "Écart de prix",
        "newSaleEur": "Nouvelle vente (EUR)",
        "newSaleNok": "Nouvelle vente (NOK)",
        "renewalEur": "Renouvellement (EUR)",
        "renewalNok": "Renouvellement (NOK)",
        "eurToNokRate": "Taux EUR → NOK",
        "saveRate": "Enregistrer le taux",
        "rateSaved": "Taux enregistré",
        "notSet": "non défini",
        "invalidRate": "Taux invalide",
        "government": "Secteur public (liste de prix Synnex)",
        "uploadPriceList": "Importer la liste de prix",
        "dropOrClick": "Déposez le fichier ici ou cliquez pour le sélectionner",
        "renewalVariants": "Prix de transition",
        "showTransitionPrices": "Afficher les prix de transition",
        "earnback": "Remise partenaire",
        "costPrice": "Prix de revient",
        "skippedRows": "Lignes ignorées",
        "hasIssue": "Signalé",
        "collapsedVariantsMessage": "Plusieurs variantes (plan de service ou modèle d'accès) ont été fusionnées dans cette ligne -- il peut exister un produit distinct non affiché ici.",
        "unknownOrderActionMessage": "Autodesk a marqué cette ligne avec une action que nous ne reconnaissons pas -- le prix n'a pas été calculé pour cette variante.",
        "unexpectedPairMessage": "Vente ou renouvellement manquant, sans que le produit soit en fin de vente -- à vérifier avant de le vendre."
    },
    "adminChangeContracts": {
        "contractUpdated": "Contrat mis à jour",
        "contractStatus": "Statut du contrat",
        "active": "Actif",
        "expired": "Expiré",
        "updateContract": "Mettre à jour le contrat"
    },
    "adminChangeContractLicense": {
        "updatedExpirationDate": "Date d'expiration mise à jour",
        "updatedParentLicenseNumber": "Numéro de licence parent mis à jour",
        "updatedItemType": "Type d'article mis à jour",
        "changeLicense": "Changer la licence",
        "updateExpirationDate": "Mettre à jour la date d'expiration"
    },
    "adminCompany": {
        "moveUsersToNewCompany": "Déplacer les utilisateurs vers une nouvelle entreprise"
    },
    "baseCatalog": {
        "updatedCourseInCatalog": "Cours mis à jour dans le catalogue.",
        "couldNotUpdateCourseInCatalog": "Impossible de mettre à jour le cours dans le catalogue.",
        "linkToCourseCatalog": "Lien vers le catalogue des cours",
        "icon": "Icône",
        "preamble": "Préambule",
        "categories": "Catégories",
        "selectLevel": "Sélectionner le niveau",
        "selectDuration": "Sélectionner la durée"
    },
    "bronnoysundAdmin": {
        "syncWithBronnoysund": "Sync. avec Brønnøysund",
        "soName": "Nom SO",
        "bsName": "Nom Brreg",
        "soAddress": "Adresse SO",
        "bsAddress": "Adresse Brreg",
        "bsZip": "Code postal Brreg",
        "soZip": "Code postal SO",
        "bsPostZip": "Code postal postal Brreg",
        "soPostZip": "Code postal postal SO",
        "bsCity": "Ville Brreg",
        "soCity": "Ville SO",
        "bsPostCity": "Ville postale Brreg",
        "soPostCity": "Ville postale SO",
        "soPostAddress": "Adresse postale SO",
        "bsPostAddress": "Adresse postale Brreg",
        "activeContracts": "Nombre de contrats actifs",
        "bankruptInBS": "Faillite chez Brreg",
        "liquidating": "Liquidation",
        "differentAddress": "Adresse différente",
        "differentPostAddress": "Adresse postale différente",
        "differentName": "Nom différent",
        "different": "Différent"
    },
    "bronnoysundDetails": {
        "numberOfEmployees": "Nombre d'employés",
        "postalCode": "Code postal",
        "city": "Ville",
        "district": "District",
        "bankrupt": "Faillite",
        "liquidating": "Liquidation"
    },
    "changeCourseUsersPassword": {
        "selectPassword": "Sélectionner le mot de passe",
        "selectEmails": "Sélectionner les emails",
        "changePasswordsForCourseUsers": "Changer les mots de passe des utilisateurs de cours",
        "untilDate": "Date limite",
        "courseName": "Nom du cours (facultatif)",
        "passwordForCourseUsers": "Mot de passe pour les utilisateurs de cours",
        "generateNewPassword": "Générer un nouveau mot de passe",
        "usedFrom": "Utilisé depuis",
        "usedUntil": "Utilisé jusqu'à",
        "inUse": "En cours d'utilisation",
        "useEmail": "Utiliser l'email"
    },
    "companiesCreated": {
        "adminEmail": "Email admin",
        "adminName": "Nom de l'admin"
    },
    "contractDetailsContainer": {
        "startingSale": "Début de la vente.",
        "futureChangesAreImplemented": "Modifications futures mises en œuvre",
        "orderDeleted": "Commande supprimée.",
        "couldNotDeleteOrder": "Impossible de supprimer la commande.",
        "orderHiddenRememberToOpenItAgainAfterChanges": "Commande masquée, n'oubliez pas de la rouvrir après les modifications.",
        "couldNotHideOrder": "Impossible de masquer la commande."
    },
    "contractSale": {
        "approval": "Approbation",
        "grantLicenseAccess": "Accorder l'accès à la licence",
        "newSale": "Nouvelle vente",
        "makeSale": "Effectuer une vente",
        "newLicense": "Nouvelle licence",
        "internalMessage": "Message interne"
    },
    "deleteCatalog": {
        "deletedCourseFromCatalog": "Cours supprimé du catalogue.",
        "couldNotDeleteCourseFromCatalog": "Impossible de supprimer le cours du catalogue."
    },
    "catalog": {
        "courseCatalog": "Catalogue de cours"
    },
    "courseGrid": {
        "registrations": "Inscriptions",
        "noConflict": "Pas de conflit",
        "firstNameInstr": "Prénom instr.",
        "lastNameInstr": "Nom de famille instr."
    },
    "createNewCourse": {
        "addedCourseToList": "Cours ajouté à la liste.",
        "couldNotAddCourseToList": "Impossible d'ajouter le cours à la liste.",
        "preamble": "Préambule",
        "superOfficeComments": "Commentaires SuperOffice",
        "addNewCourse": "Ajouter un nouveau cours"
    },
    "deleteCourse": {
        "areYouSureYouWantToDeleteCourse": "Êtes-vous sûr de vouloir supprimer le cours ?"
    },
    "registrationConflict": {
        "noDataFound": "Aucune donnée trouvée.",
        "conflicts": "Conflits"
    },
    "evaluationEmail": {
        "nameOfTemplate": "Nom du modèle",
        "template": "Modèle"
    },
    "externalCourses": {
        "confirmationOfCourseToRegistrant": "Confirmation du cours au participant"
    },
    "emailTemplates": {
        "emailTemplates": "Modèles d'emails",
        "evaluationEmail": "Email d'évaluation",
        "externalCourses": "Cours externes",
        "confirmationOfCourseRegistration": "Confirmation de l'inscription au cours",
        "movingCourses": "Déplacement des cours",
        "cancelingCourse": "Annulation du cours"
    },
    "tableData": {
        "explanationsOfVariousCodes": "Explications des différents codes",
        "updatedText": "Texte mis à jour.",
        "couldNotUpdateText": "Impossible de mettre à jour le texte.",
        "address": "Adresse",
        "comment": "Commentaire",
        "userAddress": "Adresse de l'utilisateur",
        "userPostCode": "Code postal de l'utilisateur",
        "userCity": "Ville de l'utilisateur",
        "company": "Entreprise",
        "courseName": "Nom du cours",
        "coursereginfo": "Informations sur le cours",
        "date": "Date",
        "dateOld": "Date précédente",
        "duration": "Durée",
        "durationOld": "Durée précédente",
        "email": "Email",
        "firstName": "Prénom",
        "lastName": "Nom de famille",
        "mobile": "Numéro de mobile",
        "place": "Lieu",
        "googleMapsLink": "Lien vers la carte",
        "price": "Prix",
        "priceInfo": "Informations sur le prix"
    },
    "informationTexts": {
        "informationTexts": "Textes d'information",
        "courseSchedule": "Calendrier des cours",
        "generalInformation": "Informations générales",
        "practicalInformation": "Informations pratiques",
        "preamble": "Préambule",
        "general": "Général",
        "practical": "Pratique"
    },
    "cancelRegistration": {
        "canceledCourseParticipant": "Participant au cours annulé.",
        "couldNotCancelCourseParticipant": "Impossible d'annuler le participant au cours.",
        "areYouSureYouWantToCancelYourRegistration": "Êtes-vous sûr de vouloir annuler votre inscription ?",
        "sendEmailTo": "Envoyer un email à",
        "cancel": "Annuler"
    },
    "createNewRegistration": {
        "addedCourseParticipantToList": "Participant au cours ajouté à la liste.",
        "couldNotAddCourseParticipantToList": "Impossible d'ajouter le participant au cours à la liste.",
        "newCourseParticipant": "Nouveau participant au cours",
        "sendEmailWhenRegistering": "Envoyer un email lors de l'inscription",
        "createNewCourseParticipant": "Créer un nouveau participant au cours"
    },
    "editRegistration": {
        "changedCourseParticipantInList": "Participant au cours modifié dans la liste.",
        "couldNotChangeCourseParticipantInList": "Impossible de modifier un participant au cours dans la liste.",
        "changeCourseParticipant": "Modifier le participant au cours",
        "sendEmailOnUpdating": "Envoyer un email lors de la mise à jour",
        "updateCourseParticipant": "Mettre à jour le participant au cours"
    },
    "moveRegistration": {
        "movedRegistration": "Inscription déplacée.",
        "couldNotMoveRegistration": "Impossible de déplacer l'inscription.",
        "areYouSureYouWantToMoveCourseDate": "Êtes-vous sûr de vouloir déplacer la date du cours ?",
        "sendEmailTo": "Envoyer un email à",
        "moveDate": "Date de déplacement"
    },
    "reactivateRegistration": {
        "reactivatedCourseParticipant": "Participant au cours réactivé.",
        "couldNotReactivateCourseParticipant": "Impossible de réactiver le participant au cours.",
        "areYouSureYouWantToReactivateYourRegistration": "Êtes-vous sûr de vouloir réactiver votre inscription ?",
        "sendEmailTo": "Envoyer un email à"
    },
    "registrationGrid": {
        "cancel": "Annuler",
        "reactivate": "Réactiver",
        "registered": "Inscrit",
        "cancelled": "Annulé",
        "newCourseParticipant": "Nouveau participant au cours",
        "enrolled": "Inscrit",
        "sendEvaluation": "Envoyer l'évaluation"
    },
    "registration": {
        "courseDate": "Date du cours"
    },
    "courseReport": {
        "theseAreOnCourse": "Ceux-ci sont en cours",
        "courseDeliveredDuringPeriod": "Cours dispensé pendant la période",
        "includeParticipantsFromFocus": "Inclure les participants de Focus",
        "numberOfParticipants": "Nombre de participants"
    },
    "emailLog": {
        "subject": "Sujet"
    },
    "sendCertificate": {
        "courseCertificateSent": "Certificat de cours envoyé",
        "errorWhenSendingCourseCertificate": "Erreur lors de l'envoi du certificat de cours",
        "areYouSureYouWantToSendCourseCertificates": "Êtes-vous sûr de vouloir envoyer les certificats de cours ?"
    },
    "totalReport": {
        "sendCourseCertificateAgain": "Envoyer à nouveau le certificat de cours",
        "sendCourseCertificate": "Envoyer le certificat de cours",
        "showCourseCertificate": "Afficher le certificat de cours",
        "dateOfOrder": "Date de commande"
    },
    "reports": {
        "course": "Cours",
        "search": "Recherche",
        "emailLog": "Journal des emails"
    },
    "createNewCategory": {
        "addCategoryToList": "Catégorie ajoutée à la liste.",
        "couldNotAddCategoryToList": "Impossible d'ajouter la catégorie à la liste.",
        "addCategory": "Ajouter une catégorie"
    },
    "deleteCategory": {
        "deletedCategoryFromList": "Catégorie supprimée de la liste.",
        "couldNotDeleteCategoryFromList": "Impossible de supprimer la catégorie de la liste.",
        "areYouSureYouWantToDeleteCategory": "Êtes-vous sûr de vouloir supprimer la catégorie ?"
    },
    "editComputerEquipment": {
        "updatedComputerEquipmentInList": "Équipement informatique mis à jour dans la liste.",
        "couldNotUpdateComputerEquipmentInList": "Impossible de mettre à jour l'équipement informatique dans la liste.",
        "updateComputerEquipment": "Mettre à jour l'équipement informatique"
    },
    "computerEquipment": {
        "serialNumber": "Numéro de série"
    },
    "createNewDuration": {
        "addedNewDurationToList": "Nouvelle durée ajoutée à la liste.",
        "couldNotAddNewDurationToList": "Impossible d'ajouter la nouvelle durée à la liste.",
        "value": "Valeur",
        "unit": "Unité",
        "hours": "heures",
        "days": "jours",
        "addDuration": "Ajouter une durée"
    },
    "deleteDuration": {
        "deletedDurationFromList": "Durée supprimée de la liste.",
        "couldNotDeleteDurationFromList": "Impossible de supprimer la durée de la liste.",
        "areYouSureYouWantToDeleteDuration": "Êtes-vous sûr de vouloir supprimer la durée ?"
    },
    "copyInstructor": {
        "createInstructor": "Créer un instructeur"
    },
    "createNewInstructor": {
        "addInstructor": "Ajouter un instructeur"
    },
    "deleteInstructor": {
        "deletedInstructorFromList": "Instructeur supprimé de la liste.",
        "couldNotDeleteInstructorFromList": "Impossible de supprimer l'instructeur de la liste.",
        "areYouSureYouWantToDeleteInstructor": "Êtes-vous sûr de vouloir supprimer l'instructeur ?"
    },
    "editInstructor": {
        "changedInstructorInList": "Instructeur modifié dans la liste.",
        "changeInstructor": "Modifier l'instructeur",
        "updateInstructor": "Mettre à jour l'instructeur"
    },
    "createNewLevel": {
        "addedLevelToList": "Niveau ajouté à la liste.",
        "couldNotAddLevelToList": "Impossible d'ajouter le niveau à la liste.",
        "addLevel": "Ajouter un niveau",
        "deletedLevelFromList": "Niveau supprimé de la liste.",
        "couldNotDeleteLevelFromList": "Impossible de supprimer le niveau de la liste.",
        "areYouSureYouWantToDeleteLevel": "Êtes-vous sûr de vouloir supprimer le niveau ?"
    },
    "deletePicture": {
        "deletedImageFromList": "Image supprimée de la liste.",
        "couldNotDeleteImageFromList": "Impossible de supprimer l'image de la liste.",
        "areYouSureYouWantToDeletePicture": "Êtes-vous sûr de vouloir supprimer l'image ?"
    },
    "picture": {
        "uploadNewImage": "Télécharger une nouvelle image"
    },
    "copyPlace": {
        "couldNotAddPlace": "Impossible d'ajouter l'endroit.",
        "createPlace": "Créer un endroit"
    },
    "createNewPlace": {
        "couldNotAddLocationToList": "Impossible d'ajouter l'emplacement à la liste.",
        "addLocation": "Ajouter un emplacement"
    },
    "deletePlace": {
        "deletedPlaceFromList": "Endroit supprimé de la liste.",
        "couldNotDeleteLocationFromList": "Impossible de supprimer l'endroit de la liste.",
        "areYouSureYouWantToDeleteLocation": "Êtes-vous sûr de vouloir supprimer l'emplacement ?"
    },
    "editPlace": {
        "updatedPlace": "Endroit mis à jour.",
        "couldNotUpdatePlace": "Impossible de mettre à jour l'endroit.",
        "changeLocation": "Changer l'emplacement",
        "updateLocation": "Mettre à jour l'emplacement"
    },
    "place": {
        "updateFromSuperOffice": "Mettre à jour depuis SuperOffice"
    },
    "createNewPrice": {
        "addedPriceToList": "Prix ajouté à la liste.",
        "couldNotAddPriceToList": "Impossible d'ajouter le prix à la liste.",
        "priceFormat": "Format de prix",
        "addPrice": "Ajouter un prix"
    },
    "deletePrice": {
        "deletedPriceFromList": "Prix supprimé de la liste.",
        "couldNotDeletePriceFromList": "Impossible de supprimer le prix de la liste.",
        "areYouSureYouWantToDeletePrice": "Êtes-vous sûr de vouloir supprimer le prix ?"
    },
    "resources": {
        "resources": "Ressources"
    },
    "courses": {
        "courseAccess": "Accès au cours",
        "usedFrom": "Utilisé depuis",
        "usedUntil": "Utilisé jusqu'à",
        "passwordForCourse": "Mot de passe pour le cours",
        "createNewCourse": "Créer un nouveau cours",
        "numberOfParticipants": "Nombre de participants",
        "coursePrice": "Prix du cours",
        "includeCanceledCourses": "Inclure les cours annulés",
        "answeredSurvey": "Enquête répondue",
        "sentCertificate": "Certificat envoyé"
    },
    "createEmail": {
        "emailInternalName": "Nom interne de l'email",
        "createEmail": "Créer un email"
    },
    "addContract": {
        "newContract": "Nouveau contrat",
        "thereAreNoAccountsForThisCustomer": "Il n'y a pas de comptes pour ce client. Créez une personne dans l'entreprise avant de créer un contrat.",
        "months": "mois",
        "year": "année",
        "contractStart": "Début du contrat",
        "contractRenewal": "Date de renouvellement",
        "selectContractType": "Sélectionner le type de contrat",
        "retrievesEmployees": "Récupère les employés"
    },
    "addCustomerGroup": {
        "companyAddedToGroup": "Entreprise ajoutée au groupe.",
        "couldNotAddCompanyToGroup": "Impossible d'ajouter l'entreprise au groupe."
    },
    "addImport": {
        "ticketID": "ID du ticket",
        "usedTime": "Temps utilisé",
        "numberOfMessages": "Nombre de messages"
    },
    "addNewUser": {
        "contractUpdated": "Contrat mis à jour.",
        "cannotHaveMoreUsersThanThereAreSeats": "Impossible d'avoir plus d'utilisateurs qu'il y a de sièges.",
        "updatesUsersOnContract": "Met à jour les utilisateurs sur le contrat.",
        "numberOfUsersOnContract": "Nombre d'utilisateurs sur le contrat"
    },
    "allContractsDetailsGrid": {
        "pricePerItem": "Prix par article",
        "monthlyValue": "Valeur mensuelle",
        "netGain": "Gain net",
        "residualValueAtYearStart": "Valeur résiduelle au début de l'année",
        "totalCost": "Coût total"
    },
    "allContractsGrid": {
        "invoiceResponsible": "Responsable de la facture",
        "futureChanges": "Modifications futures",
        "invoiceInterval": "Durée du contrat"
    },
    "assignLicenseRight": {
        "changesLicenseAccess": "Modifie l'accès à la licence.",
        "couldNotChangeLicenseRights": "Impossible de modifier les droits de licence."
    },
    "basicCustomerDetails": {
        "seeCustomerInformationInSuperOffice": "Voir les informations du client dans SuperOffice",
        "customerContact": "Contact client",
        "companySettings": "Paramètres de l'entreprise",
        "administrator": "Administrateur",
        "language": "Langue",
        "requiresTwoFactorAuthentication": "Nécessite 2FA",
        "federatedDomain": "Domaine fédéré"
    },
    "basicSupport": {
        "contractNumber": "Numéro de contrat",
        "seeNext": "Voir suivant",
        "agreementType": "Type d'accord",
        "includedForGroup": "Assistance incluse pour le groupe",
        "includedInSubscription": "Assistance incluse dans l'abonnement",
        "groupDeal": "Offre de groupe",
        "individualDeal": "Offre individuelle",
        "noRestrictions": "Aucune restriction",
        "users": " utilisateurs",
        "nextInvoice": "Prochaine facture"
    },
    "ceateFocusAccount": {
        "emailIsNotValid": "L'email n'est pas valide.",
        "newInvitationSent": "Nouvelle invitation envoyée.",
        "completingAccount": "Finalisation du compte.",
        "approvesFocusAccount": "Approuve le compte Focus.",
        "createAccount": "Créer un compte.",
        "sendNewInvitation": "Envoyer une nouvelle invitation",
        "completeAccount": "Finaliser le compte",
        "approveAccount": "Approuver le compte",
        "openAccount": "Créer un compte",
        "retrievesAccountStatus": "Récupère le statut du compte",
        "createFocusAccount": "Créer un compte Focus",
        "accountStatus": "Statut du compte",
        "requestedCompany": "Entreprise à laquelle l'utilisateur demande l'accès",
    },
    "credit": {
        "creditingDone": "Créditation effectuée.",
        "couldNotPerformCrediting": "Impossible d'effectuer la créditation.",
        "amountAfterBalance": "Montant après solde",
        "message": "Message"
    },
    "customerDetails": {
        "focusAccounts": "Comptes Focus",
        "peopleInSuperOffice": "Personnes dans SuperOffice",
        "companyGroup": "Groupe d'entreprise",
        "createCompanyGroup": "Créer un groupe d'entreprise",
        "loggedInToMyPage": "Connecté à Ma Page",
        "viewByGroup": "Voir par groupe",
        "showDeleted": "Afficher les éléments supprimés"
    },
    "customerProductList": {
        "domains": "Domaines",
        "coordinators": "Coordinateurs",
        "hasLicensing": "Possède une licence",
        "items": "Articles",
        "forGroup": "Pour le groupe"
    },
    "customerProductListGrid": {
        "licenseTypeDoesNotHaveLicensing": "Le type de licence n'a pas de licence",
        "accessHistory": "Historique d'accès"
    },
    "customerProductListGridRenderer": {
        "givenAccess": "Accès accordé",
        "removedAccess": "Accès retiré",
        "givenCoordinator": "Coordinateur attribué",
        "removedCoordinator": "Coordinateur retiré",
        "moved": "Déplacé",
        "productVersion": "Version du produit"
    },
    "deleteCustomerGroup": {
        "customerGroupDeleted": "Filiale supprimée.",
        "couldNotDeleteCustomerGroup": "Impossible de supprimer la filiale.",
        "areYouSureYouWantToDeleteCompanyDepartment": "Êtes-vous sûr de vouloir supprimer l'entreprise / le département ?"
    },
    "domain": {
        "automaticDomainApprovalDone": "Approbation de licence automatique effectuée.",
        "failedToPerformAutomaticDomainValidation": "Impossible d'effectuer l'approbation de licence automatique.",
        "automaticDomainApproval": "Approbation de licence automatique"
    },
    "editFocusAccount": {
        "reopenedFocusAccount": "Compte Focus rouvert.",
        "couldNotReopenFocusAccount": "Impossible de rouvrir le compte Focus",
        "changedAdmin": "Admin modifié.",
        "changedToCoAdmin": "Changé en co-admin.",
        "resendingInvitation": "Renvoi de l'invitation.",
        "deletesFocusAccount": "Supprime le compte Focus.",
        "changeFocusAccount": "Changer le compte Focus",
        "changeCompany": "Changer d'entreprise",
        "selectAsAdmin": "Sélectionner comme admin",
        "selectAsCoAdmin": "Sélectionner comme co-admin",
        "resendInvitation": "Renvoyer l'invitation",
        "reopenFocusAccount": "Rouvrir le compte Focus",
        "deleteWithoutEmail": "Supprimer sans email",
        "deleteWithEmail": "Supprimer avec email",
        "changeCompanyFor": "Changer l'entreprise pour",
        "moveUserToNewCompany": "Déplacer l'utilisateur vers une nouvelle entreprise",
        "changeEmailFor": "Changer l'email pour",
        "retireInSO": "Retirer dans SuperOffice",
        "requestedCompany": "Entreprise à laquelle l'utilisateur demande l'accès",
        "resetMfa": "Réinitialiser MFA",
        selectAsUser: "Sélectionner comme utilisateur",
    },
    "externalAccess": {
        "couldNotSelectCompanyToCustomer": "Impossible de sélectionner une entreprise pour le client.",
        "selectCompanyToCustomer": "Sélectionner une entreprise pour le client"
    },
    "license": {
        "canNotHaveMoreAccessesThanSeatsOnNamedUserLicenses": "Impossible d'avoir plus d'accès que de sièges sur les licences utilisateur nommées.",
        "numberOfUsersOnLicense": "Nombre d'utilisateurs sur la licence"
    },
    "mergeContracts": {
        "combinesContracts": "Combine les contrats",
        "targetContractNotSelected": "Contrat cible non sélectionné",
        "selectTargetContract": "Sélectionner le contrat cible"
    },
    "moveContracts": {
        "movingContracts": "Déplacement des contrats",
        "selectCompanyYouWantToMoveTo": "Sélectionner l'entreprise vers laquelle vous voulez déplacer",
        "hereYouCanSelectContractAndLicensesYouWantToMove": "Ici, vous pouvez sélectionner les contrats et les licences que vous souhaitez déplacer."
    },
    "orderOverview": {
        "orderDeleted": "Commande supprimée.",
        "couldNotDeleteOrder": "Impossible de supprimer la commande."
    },
    "support": {
        "noUserSupportAgreement": "Aucun accord de support utilisateur"
    },
    "supportGrid": {
        "usersOnTheAgreement": "Utilisateurs sur l'accord",
        "transactions": "Transactions",
        "isOnSupport": "Est en support",
        "customerNoInNimbus": "Numéro du client dans Nimbus",
        "software": "Logiciels",
        "estimatedHourlyBalance": "Solde horaire estimé",
        "spent": "Dépensé",
        "amountBalance": "Solde du montant",
        "caseNo": "N° de dossier",
        "caseDate": "Date du dossier",
        "transactionDate": "Date de transaction",
        "text": "Texte",
        "ownedBy": "Géré par",
        "hours": "Heures",
        "balance": "Solde",
        "price15minutes": "Prix par quart d'heure",
        "userOnSupportAgreement": "Utilisateur sur accord de support",
        ticketId: "Ticket ID",
        tickets: "Tickets",
        message: "Message",
        createdAt: "Date de création",
        createdBy: "Créé par",
        status: "Statut",
    },
    "editCompanyDetails": {
        "changeCompanyDetails": "Modifier les détails de l'entreprise",
        "norwegian": "Norvégien",
        "english": "Anglais",
        "twoFactorAuthentication": "Authentification à deux facteurs",
        "noEmail": "Pas d'email",
        "selectCoAdministrators": "Sélectionner des co-administrateurs",
        "federationAndSSO": "Fédération et SSO",
        "tenantId": "Tenant ID",
        "clientId": "Client ID",
        "domain": "Domaine",
    },
    "editEmails": {
        "emailUpdated": "Email mis à jour.",
        "triggerMade": "Déclencheur créé.",
        "testEmailSent": "Email de test envoyé",
        "triggerDeleted": "Déclencheur supprimé",
        "shownToCustomer": "Montré au client",
        "emailInternalName": "Nom interne de l'email",
        "updateEmailContent": "Mettre à jour le contenu de l'email",
        "typeOfTrigger": "Type de déclencheur",
        "trigger": "Déclencheur",
        "missingEnglishEmail": "Email anglais manquant",
        "missingNorwegianEmail": "Email norvégien manquant",
        "selectTrigger": "Sélectionner le déclencheur",
        "newTrigger": "Nouveau déclencheur",
        "emailRecipient": "Destinataire de l'email",
        "forEnglishLanguage": "Pour la langue anglaise",
        "saveEmailInSuperOffice": "Enregistrer l'email dans SuperOffice",
        "numberOfDaysBetweenTriggerAndEvent": "Nombre de jours entre le déclencheur et l'événement",
        "updateTrigger": "Mettre à jour le déclencheur",
        "createTrigger": "Créer un déclencheur",
        "sendTestEmail": "Envoyer un email de test",
        "deleteTrigger": "Supprimer le déclencheur"
    },
    "editLicense": {
        "licenseChangesSaved": "Modifications des licences enregistrées.",
        "endNow": "Terminer maintenant",
        "endAtTheNextDueDate": "Terminer à la prochaine date d'échéance",
        "custom": "Personnalisé",
        "addNewItem": "Ajouter un nouvel article",
        "dateOfSale": "Date de vente",
        "terminateLicense": "Résilier la licence",
        "change": "Changer",
        "salePrice": "Prix de vente",
        "hasFutureChanges": "A des modifications futures"
    },
    "emailComponents": {
        "componentChanged": "Composant modifié.",
        "componentDeleted": "Composant supprimé",
        "saveComponent": "Enregistrer le composant",
        "deleteComponent": "Supprimer le composant"
    },
    "emailContainer": {
        "emailTemplates": "Modèles d'emails",
        "emailComponents": "Composants d'emails"
    },
    "emailList": {
        "immediately": "Immédiatement",
        "noTrigger": "Pas de déclencheur",
        "triggerEvent": "Événement de déclencheur",
        "daysAfterEvent": "Jours après l'événement"
    },
    "errorLog": {
        "loginFailed": "Échec de connexion",
        "userAgent": "Agent utilisateur",
        "licenseNumber": "Numéro de licence",
        "companyNumber": "Numéro d'entreprise",
        "IPAdress": "Adresse IP",
        "unavailableLicenses": "Licences indisponibles",
        "unavailableLicense": "Licence indisponible",
        "request": "Demande",
        "error": "Erreur",
        "inequalityOnUnit": "Inégalité sur l'unité",
        "oldValue": "Ancienne valeur",
        "newValue": "Nouvelle valeur"
    },
    "gptDefinations": {
        "newFunction": "Nouvelle fonction",
        "getBackup": "Obtenir une sauvegarde",
        "functionName": "Nom de la fonction",
        "shortDescriptionSoThatGptUnderstandsWhenToUseFunction": "Courte description pour que GPT comprenne quand utiliser la fonction.",
        "content": "Contenu",
        "informationGptRetrievesWhenFunctionIsCalled": "Les informations que GPT récupère lorsque la fonction est appelée.",
        "createNewFunction": "Créer une nouvelle fonction"
    },
    "gptHelper": {
        "findRightPage": "Trouver la bonne page",
        "pageAssistance": "Assistance de la page",
        "clearChat": "Effacer le chat",
        "writeAMessage": "Écrire un message..."
    },
    "gptOverview": {
        "pages": "Pages",
        "functions": "Fonctions"
    },
    "gptRouteDefinition": {
        "updatedRoute": "Route mise à jour",
        "savedAsBackup": "Enregistré comme sauvegarde",
        "newPage": "Nouvelle page",
        "getBackup": "Obtenir une sauvegarde",
        "detailedDescriptionOfWhatIsOnPageSoGptCanAnswerQuestionsAboutPage": "Description détaillée de ce qu'il y a sur la page afin que GPT puisse répondre aux questions sur la page.",
        "detailedDescription": "Description détaillée",
        "selected": "Sélectionné",
        "saveRoute": "Enregistrer la route"
    },
    "activeUsersGrid": {
        "version": "Version",
        "licenseNo": "N° de licence",
        "offline": "Hors ligne",
        "maxSeats": "Nombre maximum de sièges",
        "loggedInNow": "Connecté maintenant",
        "onlyActiveUsers": "Uniquement les utilisateurs actifs",
        "connected": "Connecté",
        mainProductsOnly: "Produits principaux uniquement",
    },
    "loan": {
        "logOnDuration": "Durée de connexion",
        "timeZone": "Fuseau horaire",
        "newDevice": "Nouveau dispositif"
    },
    "machine": {
        "diskID": "ID du disque"
    },
    "expiredLicense": {
        "subscription": "Abonnement",
        "maintenance": "Maintenance"
    },
    "licenseChanges": {
        "terminatedLicenses": "Licences résiliées",
        "reducedSeats": "Sièges réduits",
        "newSeats": "Nouveaux sièges",
        "newLicenses": "Nouvelles licences",
    },
    "licenseUsageGrid": {
        "users": "Utilisateurs",
        "logonsPerSeat": "Connexions/Siège"
    },
    "machineInfo": {
        "windowsUsername": "Nom d'utilisateur Windows",
        "domainName": "Nom de domaine",
        "machineName": "Nom de la machine",
        "localFolder": "Dossier local",
        "systemSerialNumber": "Numéro de série du système",
        "systemDiskSignature": "Signature du disque système",
        "operatingSystem": "Système d'exploitation",
        "architecture": "Architecture"
    },
    "nlm": {
        "newOfflineFile": "Nouveau fichier hors ligne",
        "existingOfflineFiles": "Fichiers hors ligne existants",
        "createOfflineNlm": "Créer NLM hors ligne"
    },
    "nlmGrid": {
        "generateNlmFile": "Générer le fichier NLM",
        "downloadFile": "Télécharger le fichier",
        "offlineNlmFile": "Fichier NLM hors ligne",
        "createFile": "Créer un fichier",
        NlmFileWillBeCreatedAndWillBeSentToYouByEmail: "Le fichier NLM sera créé et vous sera envoyé par email.",
    },
    "personActivityGrid": {
        "mergeProductsForUsers": "Fusionner les produits pour les utilisateurs"
    },
    "rejectedLoginGrid": {
        "licensingSystem": "Système de licences",
        "approved": "Approuvé",
        "rejected": "Rejeté",
        "rejectedPersent": "Rejeté (%)"
    },
    "loginError": {
        "noLicense": "Pas de licence",
        "showDetails": "Afficher les détails"
    },
    "minSideInterests": {
        "addProductsTo": "Ajouter des produits à"
    },
    "minSideStatus": {
        "changeSaved": "Modification enregistrée",
        "activateStatusMessageOnMyPage": "Activer le message de statut sur Ma Page",
        "statusMessageNorwegian": "Message de statut en norvégien",
        "statusMessageEnglish": "Message de statut en anglais",
        "saveStatusMessage": "Enregistrer le message de statut"
    },
    "monthlyReports": {
        "companyChurn": "Attrition des entreprises (%)",
        "companyGrowth": "Croissance des entreprises (%)",
        "licenseChurn": "Attrition des sièges (%)",
        "licenseGrowth": "Croissance des sièges (%)",
        "incomeChurn": "Attrition des revenus (%)",
        "incomeGrowth": "Croissance des revenus (%)",
        "licenseDiff": "Différence de sièges.",
        "incomeDiff": "Différence de revenus MRR.",
        "incomeMRR": "Revenus MRR",
        "incomeARR": "Revenus ARR"
    },
    "moveContractInvoice": {
        "changeInvoiceDate": "Changer la date de facture.",
        "moveCost": "Coût de déplacement",
        "moveInvoiceDate": "Déplacer la date de facture",
        "newInvoiceDate": "Nouvelle date de facture"
    },
    "moveUsersToNewCompany": {
        "noCompanySelected": "Aucune entreprise sélectionnée",
        "movingOfUsersFinished": "Déplacement des utilisateurs terminé.",
        "youMustChooseACompanyToMoveTo": "Vous devez choisir une entreprise vers laquelle déplacer",
        "startsMovingOfUsers": "Début du déplacement des utilisateurs.",
        "selectUsersToMove": "Sélectionner les utilisateurs à déplacer",
        "moveUsersToNewCompany": "Déplacer les utilisateurs vers une nouvelle entreprise",
        "selectAllAccounts": "Sélectionner tous les comptes",
        "companyYouAreMovingFrom": "Entreprise d'origine",
        "chooseCompanyToMoveTo": "Choisir l'entreprise de destination",
        "newDomain": "Nouveau domaine",
        "newEmail": "Nouvel email"
    },
    "newCompany": {
        "customerCreated": "Client créé.",
        "noCustomerNumber": "Pas de numéro de client",
        "noOrgNo": "Pas de numéro d'organisation",
        "createCustomer": "Créer un client",
        "selectACompanyFromSuperOffice": "Sélectionner une entreprise depuis SuperOffice",
        "selectCustomer": "Sélectionner un client",
        "noPersonsWithEmail": "Aucune personne avec un email",
        "selectAdmin": "Sélectionner un admin",
        "sendEmailToAdmin": "Envoyer un email à l'admin",
        "createCompany": "Créer une entreprise",
        "createAdmin": "Créer un admin"
    },
    "newContractContainer": {
        "changedContractInformation": "Informations du contrat modifiées.",
        "isByggdataContract": "Doit sélectionner le vendeur sur les contrats Byggdata.",
        "startingSale": "Début de la vente.",
        "contractIsCreated": "Contrat créé"
    },
    "addGroup": {
        "newGroupAdded": "Nouveau groupe ajouté.",
        "couldNotAddNewGroup": "Impossible d'ajouter un nouveau groupe."
    },
    "addNewVersion": {
        "newVersionCreated": "Nouvelle version créée.",
        "couldNotCreateNewVersion": "Impossible de créer une nouvelle version",
        "selectName": "Sélectionner le nom"
    },
    "addProducts": {
        "productAddedToGroup": "Produit ajouté au groupe.",
        "couldNotAddProductToGroup": "Impossible d'ajouter le produit au groupe.",
        "contractInfo": "Infos du contrat",
        "nimbusCode": "Code Nimbus",
        "nimbusGroupCode": "Code de groupe Nimbus",
        "recurringInventoryItemId": "ID d'article d'inventaire récurrent",
        "setupInventoryItemId": "ID d'article d'inventaire d'installation",
        "setupPrice": "Prix d'installation",
        "startupItemId": "ID d'article de démarrage",
        "newLicense": "Nouvelle licence",
        "idForNextItem": "ID pour le prochain article",
        "quantityBeforeNextItem": "Quantité avant le prochain article"
    },
    "copyLicenseAccess": {
        "licenseYouWantToCopy": "Licence que vous souhaitez copier"
    },
    "deleteProductCategtory": {
        "groupDeleted": "Groupe supprimé.",
        "couldNotDeleteGroup": "Impossible de supprimer le groupe.",
        "deleteProductCategory": "Supprimer la catégorie de produit"
    },
    "deleteRelatedProduct": {
        "productDeleted": "Produit supprimé.",
        "couldNotDeleteProduct": "Impossible de supprimer le produit."
    },
    "deleteVersion": {
        "versionDeleted": "Version supprimée.",
        "couldNotDeleteVersion": "Impossible de supprimer la version."
    },
    "editProduct": {
        "changeDone": "Changement effectué.",
        "failedToExecuteChange": "Impossible d'exécuter le changement.",
        "newProductCreated": "Nouveau produit créé.",
        "couldNotCreateNewProduct": "Impossible de créer un nouveau produit.",
        "example": "Exemple",
        "mainProduct": "Produit principal (Uniquement pour les sous-produits)",
        "urlToWebsite": "URL du site web (Uniquement pour Webapp)",
        "vismaArticleID": "ID d'article Visma",
        "supportCategory": "Catégorie de support utilisateur",
        "descriptionOfRequirements": "Description des exigences",
        "productDescription": "Description du produit",
        "linkToProductPage": "Lien vers la page du produit",
        "notToBeLicensedInNimbus": "Ne pas être licencié dans Nimbus"
    },
    "editVersion": {
        "newFile": "Nouveau fichier",
        "fileUpdated": "Fichier mis à jour",
        "failedToUpdateFile": "Impossible de mettre à jour le fichier.",
        "fileDeleted": "Fichier supprimé.",
        "couldNotDeleteFile": "Impossible de supprimer le fichier.",
        "releaseDate": "Date de sortie",
        "selectTodaysDate": "Sélectionner la date d'aujourd'hui",
        "fileType": "Type de fichier",
        "programVersion": "Version du programme",
        "useAsLastDownload": "Utiliser comme dernier téléchargement",
        "updateFile": "Mettre à jour le fichier",
        "deleteFile": "Supprimer le fichier"
    },
    "licenseAccessGrid": {
        "mergeInFields": "Fusionner dans les champs",
        "userID": "ID utilisateur",
        "maintenanceExpiration": "Expiration de maintenance",
        "productStructure": "Structure du produit"
    },
    "groups": {
        "deleteProductGroup": "Supprimer le groupe de produits",
        "productCategories": "Catégories de produits",
        "editDescription": "Modifier la description",
        "description": "Description",
        "changeProductGroupDescription": "Changer la description du groupe de produits",
        "productCategory": "Catégorie de produit",
    },
    "import": {
        "itemHasBeenUpdated": "Article mis à jour.",
        "couldNotUpdateItem": "Impossible de mettre à jour l'article.",
        "update": "Mettre à jour",
        "newItem": "Nouvel article",
        "canBeUpdated": "Peut être mis à jour",
        "costPrice": "Prix coûtant",
        "itemType": "Type d'article",
        "interval": "Intervalle",
        "requiredQuantity": "Quantité requise",
        "userSupportIncluded": "Support utilisateur inclus",
        "showItemsWithoutChanges": "Afficher les articles sans modifications"
    },
    "items": {
        "seeContractInfo": "Voir les infos du contrat",
        "nimbusProductCode": "Code produit Nimbus",
        "setupInventoryItem": "Configurer l'article d'inventaire",
        "supportIncluded": "Support inclus",
        "licensingInNimbus": "Licences dans Nimbus",
        "canBeSold": "Peut être vendu",
        "connectedItem": "Article connecté"
    },
    "productList": {
        "parentName": "Nom parent",
        "interests": "Intérêts",
        "productCode": "Code produit"
    },
    "productStructureGrid": {
        "groups": "Groupes",
        "contractItems": "Articles de contrat",
        "itemsImport": "Importation d'articles",
        "autodeskImport": "Importation Autodesk",
        "myPageInterests": "Intérêts de Ma Page"
    },
    "productVersionGrid": {
        "versionName": "Nom de la version",
        "numberOfFiles": "Nombre de fichiers"
    },
    "deleteContactsError": {
        "errorMessageSetAsHandled": "Message d'erreur marqué comme traité.",
        "couldNotSetErrorMessageAsHandled": "Impossible de marquer le message d'erreur comme traité.",
        "areYouSureYouWantToSetAsHandled": "Êtes-vous sûr de vouloir marquer comme traité ?",
        "errorMessageIsSetAsHandledInDatabase": "Le message d'erreur est marqué comme traité dans la base de données."
    },
    "overview": {
        "failedLogins": "Connexions échouées",
        "saleLastWeek": "Ventes la semaine dernière",
        "newCompanyRequests": "Nouvelles demandes d'entreprise",
        "failedOrders": "Commandes échouées",
        "offlineLicensesRenewal": "Renouvellement des licences hors ligne",
        "reason": "Raison",
        "startedUsing": "Commencé à utiliser",
        "orderID": "ID de commande",
        "daysToRenewal": "Jours avant renouvellement",
        "terminates": "Termine",
        "proposals": "Propositions",
    },
    "pageTitle": {
        "noCustomerSelected": "Aucun client sélectionné..."
    },
    "periodChurnReport": {
        "monthlyValue": "Valeur mensuelle",
        "annualValue": "Valeur annuelle",
        "retrieveData": "Récupérer les données",
        "seatChurn": "Attrition des sièges",
        "seatGrowth": "Croissance des sièges",
        "incomeChurn": "Attrition des revenus",
        "incomeGrowth": "Croissance des revenus",
        "startSeats": "Début des sièges",
        "endSeats": "Fin des sièges",
        "startIncome": "Début des revenus",
        "endIncome": "Fin des revenus",
        "incomeDiff": "Différence de revenus",
        "seatsDiff": "Différence de sièges",
        "all": "Tous"
    },
    "personsInSuperOffice": {
        "haveAccount": "Avoir un compte",
        "deletedAccounts": "Comptes supprimés",
        "onlyWithoutAccount": "Uniquement sans compte"
    },
    "productUsageChart": {
        "licenseUsage": "Utilisation des licences"
    },
    "releaseSession": {
        "loanReleasedItMayTakeSomeTimeForItToAppear": "Prêt libéré. Cela peut prendre un certain temps avant qu'il n'apparaisse."
    },
    "newSales": {
        "newSales": "Nouvelles ventes"
    },
    "newSalesGrid": {
        "establishmentItem": "Article d'établissement",
        "establishmentItemName": "Nom de l'article d'établissement",
        "saleCostPrice": "Prix de vente coûtant",
        "saleContributionMargin": "Marge de contribution DB",
        "recurringCostPrice": "Prix de coût récurrent",
        "recurringContributionMargin": "ACV",
        "differentInVisma": "Différent dans Visma"
    },
    "renewalsGrid": {
        "timesInvoicedInPeriod": "Nombre de facturations dans la période",
        "activeNextInvoice": "Sera renouvelé"
    },
    "searchBar": {
        "somethingWentWrong": "Quelque chose s'est mal passé",
        "working": "En cours...",
        "retrievingFocusAccounts": "Récupération des comptes Focus...",
        "findCompanyForFocusAccount": "Trouver une entreprise pour le compte Focus",
        "createCustomer": "Créer un client"
    },
    "secretPage": {
        "selectPage": "Sélectionner une page"
    },
    "sessionDetails": {
        "details": "Détails",
        "licenseType": "Type de licence",
        "loggedInToMyPage": "Connecté à Ma Page",
        "loginTimeInSeconds": "Temps de connexion en secondes",
        "containerProduct": "Produit conteneur",
        "containerVersion": "Version du conteneur",
        "processID": "ID de processus",
        "windowsUser": "Utilisateur Windows"
    },
    "signalRContext": {
        "failedToConnectToSignalR": "Impossible de se connecter à SignalR",
        "actionExecuted": "Action exécutée",
        "step": "Étape",
        "infoFetched": "Infos récupérées",
        "orderValidated": "Commande validée",
        "userRightsValidated": "Droits utilisateur validés"
    },
    "supportReport": {
        "startingBalance": "Solde initial",
        "production": "Production",
        "finalBalance": "Solde final",
        "income": "Revenu",
        "showNoChanges": "Afficher les entreprises sans changements",
    },
    "webUpdates": {
        "webUpdates": "Mises à jour web",
        "seconds": "Secondes",
        "files": "Fichiers",
        "size": "Taille"
    },
    "usersWithoutCompany": {
        "country": "Pays"
    },
    "validateEmail": {
        "createAccountOnUser": "Créer un compte pour l'utilisateur.",
        "noActionRequired": "Aucune action requise.",
        "userHasBeenSentAnInvitationByEmailEtc": "Une invitation a été envoyée à l'utilisateur par email et il doit l'approuver. Alternativement, il peut choisir 'mot de passe oublié' sur Ma Page.",
        "administratorInCompanyMustApproveAccountRequestEtc": "L'administrateur de l'entreprise doit approuver la demande de compte. Si l'utilisateur se connecte sur Ma Page, il peut envoyer une nouvelle demande à l'administrateur.",
        "askUserToLoginToMyPageAndCompleteRegistration": "Demandez à l'utilisateur de se connecter à Ma Page et de compléter l'inscription.",
        "checkFocusAccount": "Vérifier le compte Focus",
        "emailYouWantToCheckFocusAccountStatusOn": "Email pour vérifier le statut du compte Focus.",
        "checkFocusAccountStatus": "Vérifier le statut du compte Focus",
        "focusAccountStatus": "Statut du compte Focus",
        "statusOnFocusAccount": "Statut sur le compte Focus",
        "actionRequired": "Action requise",
        "userSupportStatus": "Statut sur le support utilisateur",
        "other": "Autre",
        "userHasLoggedInToMyPage": "L'utilisateur s'est connecté à Ma Page.",
        "accountBlockedInWebKua": "Compte bloqué dans WebKua.",
        "personRetiredInWebKua": "Personne retraitée dans WebKua",
        "accountChanges": "Modifications du compte",
        "performedBy": "Effectué par"
    },
    "webkuaChart": {
        "showGraphAsLine": "Afficher le graphique en ligne",
        "selectProductsTimePeriodEtcAndRefreshTableToRetrieveData": "Sélectionnez les produits, la période, etc., et actualisez le tableau pour récupérer les données.",
        "selectDatasetToDisplayGraph": "Sélectionnez l'ensemble de données à afficher sur le graphique.",
        "thereIsNoDataToDisplayForSelectedPeriod": "Il n'y a pas de données à afficher pour la période sélectionnée.",
        ifYouHaveMadeChangesToSearchCriteriaEtc: "Si vous avez apporté des modifications aux critères de recherche, n'oubliez pas d'appuyer sur le bouton 'Actualiser' pour récupérer de nouvelles données.",
        emptyProductListCompanySelectionSelectsAllProductsCompanies: "La liste de produits/sélection d'entreprise vide sélectionne tous les produits/entreprises.",
        noDataInTheSearch: "Pas de données dans la recherche.",
    },
    "webkuaTable": {
        "exportToExcel": "Exporter vers Excel",
        "noVisibleExportColumns": "Affichez au moins une colonne exportable avant d'exporter vers Excel."
    },
    "helpers": {
        "noDate": "Pas de date",
        "valueMissing": "Valeur manquante",
        "noAccountOnEmail": "Aucun compte pour l'email",
        "noKnownIssues": "Aucun problème connu",
        "invitationExists": "Invitation existe",
        "accountRequestExists": "Demande de compte existe",
        "userHasNotFinishedRegistration": "L'utilisateur n'a pas terminé l'inscription"
    },
    "requestUtils": {
        "configurationSaved": "Configuration enregistrée",
        "configurationReset": "Configuration réinitialisée"
    },
    "baseCourse": {
        "updatedCcourseInList": "Cours mis à jour dans la liste.",
        "couldNotUpdateCourseInList": "Impossible de mettre à jour le cours dans la liste.",
        "updatedCourseInListAndSentAnEmailToContactPerson": "Cours mis à jour dans la liste et un email a été envoyé à la personne de contact.",
        "unknownCourse": "Cours inconnu.",
        "linkToCourse": "Lien vers le cours",
        "cancelCourse": "Annuler le cours",
        "doNotPublishCourse": "Ne pas publier le cours",
        "goToCourse": "Aller au cours",
        "registrant": "Inscrit",
        "courseConfirmationEmailTemplate": "Modèle d'email de confirmation de cours",
        "template": "Modèle",
        "sendConfirmation": "Envoyer la confirmation",
        "preamble": "Introduction",
        "superOfficeComments": "Commentaires SuperOffice",
        "duplicate": "Dupliquer",
        "day": "jour"
    },
    "standard": {
        "contractNumber": "N° de contrat",
        "reason": "Raison",
        "email": "Email",
        "phone": "Téléphone",
        "organisationNumber": "N° org.",
        "decline": "Refuser",
        "cancel": "Annuler",
        "remove": "Supprimer",
        "open": "Ouvrir",
        "company": "Entreprise",
        "processRequest": "Traiter la demande",
        "companyName": "Nom de l'entreprise",
        "adminFirstName": "Prénom de l'admin",
        "adminLastName": "Nom de famille de l'admin",
        "date": "Date",
        "contracts": "Contrats",
        "companyNo": "N° de l'entreprise",
        "contractNo": "N° de contrat",
        "contractType": "Type de contrat",
        "startDate": "Date de début",
        "nextInvoiceDate": "Date de la prochaine facture",
        "nextInvoiceCost": "Coût de la prochaine facture",
        "academicVersion": "Version académique",
        "note": "Note",
        "group": "Groupe",
        "productName": "Nom du produit",
        "recurringItem": "Article récurrent",
        "type": "Type",
        "invoiceInterval": "Durée du contrat",
        "seats": "Sièges",
        "oneTimeDiscount": "Remise unique (%)",
        "recurringDiscount": "Remise récurrente",
        "recurringDiscountPercent": "Remise récurrente (%)",
        "discount": "Remise",
        "client": "Client",
        "residualValue": "Valeur résiduelle",
        "recidualValueAtYearStart": "Valeur résiduelle au début de la nouvelle année",
        "month": "Mois",
        "year": "Année",
        "nextInvoicingDate": "Date de la prochaine facturation",
        "newSale": "Nouvelle vente",
        "licenseNumber": "N° de licence",
        "name": "Nom",
        "expirationDate": "Fin de maintenance",
        "terminationDate": "Date de fin",
        "discountPercent": "Remise (%)",
        "companyNumber": "N° de client",
        "customerName": "Nom du client",
        "showOnlyTerminationDate": "Afficher uniquement pour la date de fin",
        "activationDate": "Date d'activation",
        "orderDate": "Date de commande",
        "orderType": "Type de commande",
        "errorText": "Message d'erreur",
        "changedBy": "Modifié par",
        "activeOrder": "Commande active",
        "deleted": "Supprimé",
        "requestDate": "Date de demande",
        "inNimbus": "Dans Nimbus",
        "inSuperoffice": "Dans SuperOffice",
        "blockedInNimbus": "Bloqué dans Nimbus",
        "blockedInCosmos": "Bloqué dans Cosmos",
        "duplicated": "Dupliqué",
        "delete": "Supprimer",
        "change": "Changer",
        "parentLicenseNumber": "N° de licence parent.",
        "product": "Produit",
        "nextInvoice": "Date de la prochaine facture",
        "courseName": "Nom du cours",
        "selectProducts": "Sélectionner les produits",
        "evaluation": "Évaluation",
        "noEvaluation": "Pas d'évaluation",
        "addNewEvaluationForm": "Ajouter un nouveau formulaire d'évaluation",
        "doNotPublish": "Ne pas publier",
        "description": "Description",
        "selectPrice": "Sélectionner le prix",
        "address": "Adresse",
        "firstName": "Prénom",
        "lastName": "Nom de famille",
        "activated": "Activé",
        "createdBy": "Créé par",
        "back": "Retour",
        "next": "Suivant",
        "quantity": "Quantité",
        "price": "Prix",
        "executionDate": "Date d'exécution",
        "account": "Compte",
        "copies": "Copies",
        "newCourse": "Nouveau cours",
        "duration": "Durée",
        "copy": "Copier",
        "addCourse": "Ajouter un cours",
        "areYouSureYouWantToDeleteCourse": "Êtes-vous sûr de vouloir supprimer le cours ?",
        "updateCourse": "Mettre à jour le cours",
        "changeCourse": "Changer le cours",
        "conflicts": "Conflits",
        "cancelled": "Annulé",
        "trainingRoom": "Salle de formation",
        "place": "Lieu",
        "adskCourseId": "ID du cours ADSK",
        "instructor": "Instructeur",
        "assistantInstructor": "Assistant instructeur",
        "linkToCourse": "Lien vers le cours",
        "maxNumberOfSeats": "Nombre maximum de sièges",
        "postCode": "Code postal",
        "selectComputerEquipment": "Sélectionner l'équipement informatique",
        "courseWithTotalPrice": "Cours avec prix total",
        "priceInformation": "Informations sur le prix",
        "additionalInformationForParticipantUponConfirmationOfRegistration": "Informations supplémentaires pour le participant lors de la confirmation de l'inscription",
        "courseList": "Liste des cours",
        "save": "Enregistrer",
        "complete": "Compléter",
        "code": "Code",
        "confirmationCourseRegistration": "Confirmation de l'inscription au cours",
        "reset": "Réinitialiser",
        "cancelingCourse": "Annulation du cours",
        "movingCourses": "Déplacement des cours",
        "updatedText": "Texte mis à jour.",
        "couldNotUpdateText": "Impossible de mettre à jour le texte.",
        "contactPersonForInvoice": "Personne de contact pour la facture",
        "mobileNo": "N° de mobile",
        "invoiceEmail": "Email de facture",
        "orderReference": "N° de commande/référence de la facture",
        "employeeNumber": "N° d'employé",
        "otherComments": "Autres commentaires",
        "move": "Déplacer",
        "reactivate": "Réactiver",
        "lastChanged": "Dernier changement",
        "courseParticipant": "Participant au cours",
        "from": "De",
        "to": "À",
        "level": "Niveau",
        "comments": "Commentaires",
        "newCategory": "Nouvelle catégorie",
        "category": "Catégorie",
        "selectFromSuperOffice": "Sélectionner depuis SuperOffice",
        "newDuration": "Nouvelle durée",
        "addedInstructorToList": "Instructeur ajouté à la liste.",
        "newInstructor": "Nouvel instructeur",
        "adskInstructorId": "ID de l'instructeur ADSK",
        "city": "Ville",
        "newLevel": "Nouveau niveau",
        "addedLocationToList": "Emplacement ajouté à la liste.",
        "newPlace": "Nouvel endroit",
        "show": "Afficher",
        "newPrice": "Nouveau prix",
        "computerEquipment": "Équipement informatique",
        "prices": "Prix",
        "pictures": "Images",
        "course": "Cours",
        "numberOfDays": "Nombre de jours",
        "emails": "Emails",
        "newEmail": "Nouvel email",
        "emailSubject": "Sujet de l'email",
        "currency": "Devise",
        "userSupport": "Support utilisateur",
        "academic": "Académique",
        "customerNumber": "Numéro de client",
        "contractManager": "Responsable du contrat",
        "retrievingData": "Récupération des données",
        "addCompanyDepartment": "Ajouter une entreprise / un département",
        "changesFocusAccount": "Modifications du compte Focus.",
        "couldNotChangeFocusAccount": "Impossible de changer le compte Focus.",
        "importTicket": "Importer un dossier",
        "getTicket": "Obtenir un dossier",
        "title": "Titre",
        "changeUsers": "Changer les utilisateurs",
        "employee": "Employé",
        "module": "Module",
        "item": "Article",
        "changes": "Modifications",
        "expired": "Expiré",
        "activeOnly": "Uniquement actif",
        "active": "Actif",
        "licenses": "Licences",
        "invoiceCost": "Coût de la facture",
        "newContract": "Nouveau contrat",
        "orderOverview": "Aperçu des commandes",
        "moveContracts": "Déplacer les contrats",
        "mergeContracts": "Fusionner les contrats",
        "showForGroup": "Afficher pour le groupe",
        "domainAccess": "Accès au domaine",
        "access": "Accès",
        "licensingCoordinator": "Coordinateur de licences",
        "assignLicenseRights": "Attribuer les droits de licence",
        "assignDemoLicenseRights": "Attribuer les droits de licence de démonstration",
        "giveEveryoneLicenseAccess": "Donner l'accès à la licence à tout le monde",
        "makeEveryoneACoordinator": "Faire de tout le monde un coordinateur",
        "removeAllLicenseAccess": "Supprimer tous les accès à la licence",
        "removeAllCoordinators": "Supprimer tous les coordinateurs",
        "action": "Action",
        "sendEmail": "Envoyer un email",
        "customerDetails": "Détails du client",
        "contract": "Contrat",
        "terminated": "Résilié",
        "focusAccount": "Compte Focus",
        "student": "Étudiant",
        "credit": "Crédit",
        "amount": "Montant",
        "createsCustomer": "Crée un client",
        "role": "Rôle",
        "accesses": "Accès",
        "coordinator": "Coordinateur",
        "created": "Créé",
        "productList": "Liste des produits",
        "modules": "Modules",
        "offline": "Hors ligne",
        "variant": "Variante",
        "version": "Version",
        "numberOfSeats": "N° de sièges",
        "loan": "Prêt",
        "automaticLicenseApproval": "Approbation automatique des licences",
        "copyLicenseRights": "Copier les droits de licence",
        "externalLicenseRights": "Droits de licence externes",
        "username": "Nom d'utilisateur",
        "external": "Externe",
        "license": "Licence",
        "person": "Personne",
        "loanId": "ID de prêt",
        "returned": "Retourné",
        "borrowed": "Emprunté",
        "newLicensingSystem": "Nouveau système de licences",
        "user": "Utilisateur",
        "domain": "Domaine",
        "machine": "Machine",
        "changeEmail": "Changer l'email",
        "blocked": "Bloqué",
        "retired": "Retraité",
        "changesLicenseAccesses": "Modifications des accès aux licences.",
        "language": "Langue",
        "selectAdministrator": "Sélectionner l'administrateur",
        "components": "Composants",
        "add": "Ajouter",
        "selectTriggerType": "Sélectionner le type de déclencheur",
        "days": "jours",
        "triggerDescription": "Description du déclencheur",
        "variables": "Variables",
        "changeLicense": "Changer la licence",
        "renewalPrice": "Prix de renouvellement",
        "productCode": "Code produit",
        "timestamp": "Horodatage",
        "errorType": "Type d'erreur",
        "function": "Fonction",
        "backupRetrieved": "Sauvegarde récupérée",
        "noBackupFound": "Aucune sauvegarde trouvée",
        "shortDescription": "Courte description",
        "saveAsBackup": "Enregistrer comme sauvegarde",
        "sendingYouTo": "Vous envoyer à",
        "working": "Travail en cours",
        "activeUsers": "Utilisateurs actifs",
        "freeUpLoans": "Libérer les prêts",
        "licenseModel": "Modèle de licence",
        "expiryDate": "Date d'expiration",
        "loanStart": "Début du prêt",
        "accountID": "ID de compte",
        "department": "Département",
        "companyID": "ID de l'entreprise",
        "number": "Numéro",
        "school": "École",
        "processes": "Processus",
        "mainProduct": "Produit principal",
        "mainLicenseNo": "N° de licence principal",
        "productVersion": "Version du produit",
        "fileVersion": "Version du fichier",
        "seat": "Siège",
        "maxSeat": "Siège maximum",
        "fileName": "Nom du fichier",
        "sessionID": "ID de session",
        "started": "Commencé",
        "stopped": "Arrêté",
        "loanID": "ID de prêt",
        "expires": "Expire",
        "lastRenewed": "Dernier renouvellement",
        "returnType": "Type de retour",
        "releasedBy": "Libéré par",
        "volumeID": "ID de volume",
        "operatingSystem": "Système d'exploitation",
        "macAddresses": "Adresses MAC",
        "virtualMachine": "Machine virtuelle",
        "personID": "ID de la personne",
        "expiredLicenses": "Licences expirées",
        "loginFailed": "Échec de connexion",
        "licenseExploitation": "Exploitation des licences",
        "logons": "Connexions",
        "hoursLoggedOn": "Heures connectées",
        "hoursPerSeat": "Heures/Siège",
        "offlineLicenses": "Licences hors ligne",
        "personActivity": "Activité de la personne",
        "rejectedLogin": "Connexion refusée",
        "products": "Produits",
        "myPageStatus": "Statut de Ma Page",
        "period": "Période",
        "terminatedItems": "Articles résiliés",
        "newItems": "Nouveaux articles",
        "changedItems": "Articles modifiés",
        "activeItems": "Articles actifs",
        "errorItems": "Articles en erreur",
        "licenseName": "Nom de la licence",
        "addProductGroup": "Ajouter un groupe de produits",
        "groupName": "Nom du groupe",
        "newVersion": "Nouvelle version",
        "addProduct": "Ajouter un produit",
        "recurringPrice": "Prix récurrent",
        "seatsPerQuantity": "Sièges par licence",
        "cloudLicensing": "Licence cloud",
        "canSell": "Peut vendre",
        "additionalProduct": "Produit supplémentaire",
        "areYouSureYouWantToDelete": "Êtes-vous sûr de vouloir supprimer ?",
        "productCategory": "Catégorie de produit",
        "deleteProduct": "Supprimer le produit",
        "deleteVersion": "Supprimer la version",
        "changeProduct": "Changer le produit",
        "systemRelatedProducts": "Produits liés au système",
        "changeVersion": "Changer la version",
        "nimbusCode": "Code Nimbus",
        "uploadExcelFile": "Télécharger un fichier Excel",
        "submodules": "Sous-modules",
        "selectProduct": "Sélectionner un produit",
        "setAsHandled": "Marquer comme traité",
        "overview": "Aperçu",
        "companyChurn": "Attrition des entreprises",
        "companyGrowth": "Croissance des entreprises",
        "create": "Créer",
        "report": "Rapport",
        "seller": "Vendeur",
        "invoiceDate": "Date de facture",
        "productGroup": "Groupe de produits",
        "renewals": "Renouvellements",
        "costPrice": "Prix coûtant",
        "netGain": "DB",
        "sales": "Ventes",
        "notReleased": "Non publié",
        "noAccountSelected": "Aucun compte sélectionné",
        "licenseAccess": "Accès à la licence",
        "extendTrial": "Prolonger l'essai",
        "stopTrial": "Arrêter l'essai",
        "state": "État",
        "answer": "Réponse",
        "approvedOffers": "Offres approuvées",
        "waitingForResponse": "En attente d'une réponse",
        "newOffer": "Nouvelle offre",
        "sent": "Envoyé",
        "deadline": "Date limite",
        "lastContact": "Dernier contact",
        "comment": "Commentaire",
        "offerNo": "N° d'offre",
        "offerNumber": "Numéro d'offre",
        "totalAnnualSubscription": "Total - abonnement annuel",
        "totalUntilRenewal": "Total - jusqu'au renouvellement",
        "status": "Statut",
        "frontPage": "Page d'accueil",
        "newPurchase": "Nouvel achat",
        "manageAccesses": "Gérer les accès",
        "ourProposal": "Notre proposition",
        "validUntil": "Valide jusqu'au",
        "setDiscountOnAll": "Appliquer une remise sur tout",
        "setDiscount": "Appliquer une remise",
        "internalNote": "Note interne",
        "customer": "Client",
        "recipientOfOffer": "Destinataire de l'offre",
        "noteToCustomer": "Note pour le client",
        "deleteOffer": "Supprimer l'offre",
        "createNewOffer": "Créer une nouvelle offre",
        "expiredOffers": "Offres expirées",
        "licenseType": "Type de licence",
        "licenseNr": "N° de licence",
        "priceToRenewal": "Prix de renouvellement",
        "offer": "Offre",
        "close": "Fermer",
        thereAreNoLicensesToDisplayHere: "Il n'y a aucune licence à afficher ici.",
        details: "Détails",
        hiddenChanges: "Modifications cachées",
        newLicense: "Nouvelle licence",
        viewExpiredLicenses: "Voir les licences expirées",
        maintenance: "Maintenance",
        unitCost: "Coût unitaire",
        totalPrice: "Prix total",
        paymentOverview: "Aperçu des paiements",
        renewalDate: "Date de renouvellement",
        moveInvoiceDate: "Déplacer la date de facturation",
        totalBeforeDiscount: "Total avant remise",
        totalInvoiceAmount: "Montant total de la facture",
        goToApproval: "Aller à l'approbation",
        start: "Démarrer",
        contractInformation: "Informations sur le contrat",
        sellerInSuperOffice: "Vendeur dans SuperOffice",
        overrideSeller: "Remplacer le vendeur",
        useSellerInSuperOffice: "Utiliser le vendeur dans SuperOffice",
        missingAccount: "Compte manquant",
        hide: "Cacher",
        sum: "Somme",
        invoiceInformation: "Informations de facturation",
        missingInSuperOffice: "Manquant dans SuperOffice",
        customersOrderNumber: "N° de commande du client",
        invoiceResponsible: "Responsable de la facture",
        updateContract: "Mettre à jour le contrat",
        trialLicenses: "Licences d'essai",
        nonAcademic: "Non académique",
        unpackSeats: "Déballer les sièges",
        includeRestructuring: "Inclure la restructuration",
        new: "Nouveau",
        activatedOnMyPage: "Activé sur MaPage",
        accounts: "Comptes",
        admin: "Admin.",
        allCompanies: "Toutes les entreprises",
        newCompanies: "Nouvelles entreprises",
        productID: "ID du produit",
        numberOfUsers: "Nombre d'utilisateurs",
        companyGroupID: "ID du groupe d'entreprises",
        monthlyValueOfLicenses: "Valeur mensuelle des licences",
        yearlyValueOfLicenses: "Valeur annuelle des licences",
        reports: "Rapports",
        invoiceAmount: "Montant de la facture",
        added: "Ajouté",
        showM2S: "Afficher M2S",
        salePrice: "Prix de vente",
        createNewPeopleInSuperOffice: "Créer de nouvelles personnes dans SuperOffice",
        salesAmount: "Montant des ventes",
        dateOfMove: "Date du déménagement",
        none: "Aucun",
        noPriceInformation: "Pas d'informations de prix",
        noTimeSpent: "Pas de temps passé",
        domainsThatAutomaticallyApproveAccounts: "Domaines qui approuvent automatiquement les comptes",
        customerProposal: "Proposition client",
        customerNo: "N° client",
        reasonForSale: "Raison de la vente",
        addDescription: "Ajouter une description",
        pleaseEnterValidEmailAddress: "Veuillez entrer une adresse email valide",
        lastNameRequired: "Nom de famille requis",
        firstNameRequired: "Prénom requis",
        createFocusAccount: "Créer un compte Focus",
    },
    "simpleTable": {
        "searchInTable": "Rechercher dans le tableau",
        "last24Hours": "Dernières 24 heures",
        "nextYear": "L'année prochaine",
        "nextMonth": "Le mois prochain",
        "nextWeek": "La semaine prochaine",
        "today": "Aujourd'hui",
        "lastWeek": "La semaine dernière",
        "lastMonth": "Le mois dernier",
        "lastYear": "L'année dernière",
        "custom": "Personnalisé",
        "selectAll": "Tout sélectionner",
        "selectAllPossible": "Tout sélectionner possible ({{maxCount}})",
        "copy": "Copier",
        "export": "Exporter",
        "date": "Date",
        "from": "De",
        "to": "À",
        "show": "Afficher",
        "search": "Recherche",
        "showQuantity": "Afficher la quantité",
        "total": "Total",
        "saveTableConfiguration": "Enregistrer la configuration du tableau",
        "resetTableConfiguration": "Réinitialiser la configuration du tableau",
        "seller": "Vendeur"
    },
    reasonsForSale: {
        Other: "Autre",
        Restructuring: "Non comptabilisé dans le taux de désabonnement",
        Bankruptcy: "Faillite",
        Retired: "Retraité",
        NoNeedForProduct: "Pas besoin du produit",
        ChangedToCompetitor: "J'ai acheté un produit concurrent",
        SaveMoney: "Arrêté pour économiser de l'argent"
    },
    "froala": {
        "addTextOrImages": "Ajouter du texte ou des images ici"
    },
    "shop": {
        "webshop": "Boutique en ligne",
        "offer": "Offre",
        "selectProduct": "Sélectionner un produit",
        "selectQuantity": "Sélectionner la quantité",
        "register": "S'inscrire",
        "confirmation": "Confirmation",
        "currentContract": "Contrat actuel",
        "contractNumber": "N° de contrat",
        "contractDetails": "Détails du contrat",
        "seats": "Sièges",
        "productName": "Nom du produit",
        "renewalDate": "Date de renouvellement",
        "action": "Action",
        "add": "Ajouter",
        "searchInProducts": "Rechercher dans les produits",
        "perYear": "par an",
        "productPage": "Page du produit",
        "addNewOrExisting": "Ajouter des sièges ou des licences de produit",
        "moduleNames": "Modules",
        "requires": "Requiert",
        "addSeats": "Ajouter des sièges",
        "addLicense": "Ajouter une licence",
        "newLicense": "Nouvelle licence",
        "addNewLicense": "Ajouter une nouvelle licence",
        "newContract": "Nouveau contrat",
        "addNewContract": "Ajouter un nouveau contrat",
        "licenseNumber": "N° de licence",
        "cart": "Panier",
        "freeSeatAlteration": "Modification de siège gratuite",
        "duration": "Durée",
        "months": "mois",
        "type": "Type",
        "sumSubscription": "Somme de l'abonnement",
        "sumUntilRenewal": "Somme jusqu'au renouvellement",
        "pricePerSeat": "Prix standard",
        "buyMoreMsg": "Tout produit supplémentaire sera ajouté à ce contrat. Terminez l'achat ou annulez pour sélectionner un contrat différent.",
        "priceNowMsg": "Prix total pour le renouvellement",
        "recurringTotalPrice": "Prix total récurrent",
        "sumInvoiced": "Somme facturée",
        "invoiceInterval": "Intervalle de facturation (mois)",
        "invoiceIntervalInfoText": "Ne peut ajouter des produits qu'aux contrats d'une durée de 12 mois.",
        "priceNow": "Facturé maintenant",
        "orderNum": "N° de commande",
        "yourOrderNumTooltip": "Utilisez le numéro de commande pour envoyer la facture aux personnes désignées de votre entreprise.",
        "buyMore": "Acheter plus",
        "goToConfirmation": "Aller à la confirmation",
        "acceptCounterProposal": "Accepter la contre-proposition",
        "createProposal": "Créer une proposition",
        "saveOffer": "Enregistrer l'offre",
        "subscriptionPrice": "Prix abonn.",
        "iAcceptAll": "J'accepte tout",
        "terms": "termes",
        "orderCompleted": "Commande terminée",
        "thankYouForPurchase": "Merci pour votre achat",
        "orderCompleted2": "La commande n°{{orderId}} est terminée et sera disponible pour une utilisation immédiate. N'oubliez pas de distribuer l'accès à la licence aux utilisateurs.",
        "productOverview": "Aperçu du produit",
        "noItemsInCart": "Vous n'avez aucun article dans votre panier",
        "addProductFirst": "Ajoutez d'abord un produit",
        "backToWebshop": "Retour à la boutique en ligne",
        "contractResponsible": "Responsable du contrat",
        "newLicenseMsg": "Ici, vous créez un nouveau contrat avec une nouvelle licence. Commencez à partir d'aujourd'hui.",
        "addSeatsMsg": "Ici, vous pouvez ajouter des sièges aux licences existantes.",
        "addLicenseMsg": "Ici, vous pouvez ajouter de nouvelles licences aux contrats existants qui n'incluent pas déjà ce programme.",
        "numberOfProducts": "Nombre de produits",
        "confirmOfferTitle": "Confirmer l'offre",
        "confirmOfferText": "Êtes-vous sûr de vouloir confirmer l'offre ?",
        "confirmOfferTextDraft": "Cela enverra l'offre au client.",
        "confirmOfferTextPending": "Cela écrasera l'offre existante au client",
        "confirmOfferTextCounterProposal": "Cela supprimera la contre-proposition du client et écrasera l'offre existante au client",
        "confirmOfferTextAccepted": "L'offre a déjà été acceptée par le client. Cela rouvrira l'offre.",
        "confirmOfferTextRejected": "L'offre a déjà été rejetée par le client. Cela rouvrira l'offre.",
        "confirmOfferTextExpired": "L'offre a expiré. Cela rouvrira l'offre.",
        "sendOffer": "Envoyer l'offre",
        "cartOverview": "Aperçu du panier",
        "offerSaved": "Offre enregistrée",
        "sendingOffer": "Envoi de l'offre",
        "acceptingCounterProposal": "Acceptation de la contre-proposition",
        "proposalDeleted": "Proposition supprimée",
        "offerSent": "Offre envoyée",
        "offerAccepted": "Offre acceptée",
        "noProposalRecepientsError": "Aucun destinataire de proposition, veuillez en ajouter un ou plusieurs",
        "noProductsError": "Aucun produit dans le panier",
        "oneTimeDiscountTotal": "Total remise unique",
        "recurringDiscountTotal": "Total remise récurrente"
    },
    "licenseType": {
        "slm": "Utilisateur unique",
        "nlm": "Multi-utilisateur",
        "namedUser": "Utilisateur nommé",
        "oneTime": "Produit unique",
        "unknown": "Inconnu"
    },
    "proposalState": {
        "Accepted": "Accepté",
        "Pending": "En attente (En attente du client)",
        "Draft": "Brouillon",
        "CounterProposal": "Contre-proposition (En attente du vendeur)",
        "Rejected": "Rejeté",
        "Expired": "Expiré",
        "Active": "Actif",
    },
    contract: {
        change: "Changer",
    }
}
